import { JoyTour } from "./toursteps/dashboard_tour";
import { Avatar, Col, Drawer, DrawerProps, Dropdown, Form, Layout, Menu, Modal, Popover, Row, Select, Space, Tabs, Tooltip, notification } from "antd";
import { CallServices, CoreServices, ReportServices, SocialmediaServices, WhatsappService } from "../../base/service/apiServices";
import { ClearStorage, GetItemFromStorage, SetItemInStorage } from "../../custom_hooks/useStorage";
import { Cookie, MapAgentTrackerData, getCallBlastAutoAnswer, isJSON, hassAccess, findLoadableImageUrl } from "../../base/utils";
import { useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import AgentQueueTracker from "../main_layout/header/agentStatusTracker/agentQueueTracker";
import { AgentStateAction } from "../../store/slices/agent-status/agent_state";
import AgentStatusTracker from "../main_layout/header/agentStatusTracker/agentStatusTracker";
import { AntInput } from "../../shared/widges/antinput";
import { BasicMenu } from "./menus";
import { CallPopUpAgentActions } from "../../store/slices/voice_call_slice/call_popup_agent";
import { CallService } from "../../services/call_service";
import { ChatActions } from "../../store/slices/chat_slice/chat_slice";
import { ChatState } from "../../base/models/model";
import { ContactsMenu } from "./contactmenus";
import { CustomeMenu } from "./menucustome";
import EmptyNotify from "../../styles/images/emptynotification.png";
import closeicon from "../../styles/images/closeicon.svg";
import Item from "antd/lib/list/Item";
import { LocalStorage } from "../../custom_hooks/localStorageKeys";
import Lottie from "lottie-react";
import { setCallNotification, setNotification } from "../../store/slices/main_layout_slice/notification";
import { Outlet } from "react-router";
import { CHAT_BOX_PLAN_ID, ROLES, config } from "../../base/constant";
import { Types } from "../../base/action/action";
import { WtButton } from "../../shared/widges/Button/button";
import _, { isEmpty } from "lodash";
import { getAllUsers } from "../../store/api/user_management";
import jwt_decode from "jwt-decode";
import moment from "moment";
import { shortcutKeyActions } from "../../store/slices/shortcutkeys_slice/shortcutkeys_slice";
import { sidebarActions } from "../../store/slices/main_layout_slice/sidebar_slice";
import store from "../../store/redux-store/root_store";
import styles from "./main.module.scss";
import { useDispatcher } from "../../custom_hooks/use_app_dispatch";
import { useHotkeys } from "react-hotkeys-hook";
import { useSelector } from "react-redux";
import presenceService from "../../base/service/presence";
import axios from "axios";
import Joyride from 'react-joyride';
import AgentFullScreen from "../joinMeetingScreen/agentFullScreen/agentFullScreenComponent";
import InternalChatNotification from "../webChatScreen/chatWidgets/chatRightSidebar/internalChatNotification";
import callChatService from "../../base/service/chatService";
import { Cookies } from "../../utils/cookies";
import { getAllContactListActions } from "../../store/slices/agnetWorkspaceContactslice/contactsSlice";
import Messagetop from '../../styles/images/messagetop.svg'
import { Data } from "emoji-mart";
import logofull from "../../styles/images/worktual-white.svg";
import closebars from "../../styles/images/closebars.svg";
import menubarsimg from "../../styles/images/menubars.svg";
import avatar from "../../styles/images/worktual-small.svg";
import menumobilelogo from "../../styles/images/mobilemenulogo.svg";
import Timer from "./timer";
import OncallPad from "../../webchat/oncallpad";
import Dynamicdash from "../main_layout/navigation/aichatbox";
import { DynamicDashboardSliceActions } from '../../store/slices/dynamicDash_slice/index';
import { LOGIN_USER } from "../../constants/reducer_names";
import { outboundCampaignSliceAction } from "../../store/slices/outboundCampaign/outboundCampaignslice";
import { Upgdradeplan } from "../../shared/widges/upgrademodal/commonupgrade";
import close_icon from '../../styles/images/close_iconwhite.svg';
import { dashBoardSliceActions } from "../../store/slices/dashboard_slice/dashBoard";
import Aigenerate from '../../styles/images/aigenerate.svg';

function MainLayout() {
  const dispatch: any = useDispatcher();
  const loginUserData = useSelector((state: any) => state?.loginUser?.loginUserDetails);
  const chatReducer: ChatState = useSelector((state: any) => state.chatReducer);
  const dynamicDashboard = useSelector((state: any) => state.dynamicDashboard)
  let { currentSession, incomingcallDetails, servicePlan, unReadMessgCount } = chatReducer;
  const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
  const userRoleId = GetItemFromStorage(LocalStorage.ROLE_ID);
  const userEmailId = GetItemFromStorage(LocalStorage.USER_EMAIL);
  const LoginCcaasUserDetails: any = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
  console.log('LoginCcaasUserDetails', LoginCcaasUserDetails)
  let statusColor = GetItemFromStorage("WORK_STATUS_COLOR");
  document.documentElement.style.setProperty("--agentCoolor", statusColor);
  const stateChange = LocalStorage.STATE_CHANGE;
  const { Sider, Content } = Layout;
  const [collapsed, setCollapsed] = useState(true);
  const roomData: any = store.getState().chatReducer;
  const { sharingStatus, annotationEnable, remoteVideoSize } = store.getState().sharingReducerState;
  const shortcutKeysSlice = useSelector((state: any) => state.shortcutKeys);
  let LoginUserDetails: any = accessToken && jwt_decode(accessToken);
  const navigate = useNavigate();
  const forceCloseSideBarOverLaySettings: any = useSelector((state: any) => state.sideBar.forceCloseSideBarOverLaySettings);
  const forceCloseSideBarOverLayReports: any = useSelector((state: any) => state.sideBar.forceCloseSideBarOverLayReports);
  const forceCloseSideBarOverLayContacts: any = useSelector((state: any) => state.sideBar.forceCloseSideBarOverLayContacts);
  const notificationRefreshData: any = useSelector((state: any) => state.userSettings)
  const sideBarOverlayContacts: any = useSelector((state: any) => state.sideBar.sideBarOverlayContacts);
  const sideBarOverlaySettings: any = useSelector((state: any) => state.sideBar.sideBarOverlaySettings);
  const { queueTrackerData }: any = useSelector((state: any) => state.queueTracker);
  const notificationList: any = useSelector((state: any) => state.notification.notificationList);
  const { readMessages, unreadMessages, unreadCount, callNotification }: any = useSelector((state: any) => state.notification);
  const InitialSetupReducer = useSelector((state: any) => state.agentStatus);
  const { agentstatusList, agentstatusdata } = InitialSetupReducer;
  let { users } = useSelector((state: any) => state.userList);
  const [languageChange, setLanguageChange] = useState<any>("en");
  const [domainUrl, serDomainUrl] = useState<any>(false);
  const [WSSURL, setWSSURL] = useState<any>("");
  const { status: statusMenuList, currentStatus } = useSelector((state: any) => state.agentState);
  const [full, setFull] = useState<any>(false);
  const [time, setTime] = useState<any>(0);
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState<DrawerProps["placement"]>("right");
  const [badgeFlag, setBadgeFlag] = useState<boolean>(false);
  const [tempNotification, setTempNotifcation] = useState<any>([]);
  const [count, setCount] = useState<any>(unreadCount?.unReadCount);
  const { unregister } = CallService(dispatch, navigate);
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState<any>("English");
  const popUpDetails: any = useSelector((state: any) => state.callPopUpDetails);
  const { isDialPadOpen, isCalling, status, incomingCallDetail, callDetails, currentCallDuration } = popUpDetails;
  const callLoginUserAgent: any = useSelector((state: any) => state.callLoginUserAgent);
  const [createModal, setCreateModal] = useState(false);
  const [buttonSave, setButtonSave] = useState<boolean>(false);
  let { isSuccess } = callLoginUserAgent;
  const [userType, setUserType] = useState<any>("");
  const [emptynotify, setEmptynotify] = useState(true);
  const [countryCode, setCountryCode] = useState('');
  const [currentUserType, setCurrentUserType] = useState();
  let { EndCallfunction } = CallService(dispatch, navigate);
  const [isTourRunning, setIsTourRunning] = useState(false);
  const [currentStep, setCurrentStep] = useState(-1);
  const productid = GetItemFromStorage(LocalStorage.PRODUCT_ID);
  const spanRef: any = useRef(null);
  const [supervisorStatus, setSupervisorStatus] = useState<any>('');
  const loginPlanDetail = GetItemFromStorage(LocalStorage.PLAN_ID);
  const agentList: any = useSelector((state: any) => state.agentTracker.agentList)
  const [notifications, setNotifications] = useState<any>([]);
  const [unread, setUnreadMsg] = useState<any>([]);
  const [unReadCount, setUnReadCount] = useState<any>([]);
  const [totalCount, setTotalCount] = useState<any>([]);
  const [emailApointmentAddOn, setEmailApointmentAddOn] = useState<any>({ "email": false, "booking": false })
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [resetTrigger, setResetTrigger] = useState(false);
  const InitialReducer = useSelector((state: any) => state.agentStatus);
  const profileRef = useRef<any>(null);
  const handleDropdownList = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };
  const [openProfile, setOpenProfile] = useState(false)
  const [isVisible, setIsVisible] = useState(false);
  const divRef = useRef<any>(null);
  const arrowRef = useRef<any>(null);
  const contentRef = useRef<any>(null);
  const appIcon = useRef<any>(null);
  const profile = useRef<any>(null);
  const [profileImage, setprofileImage] = useState<any>(null)

  // useEffect(() => {
  //   const handleClickOutside = (e: MouseEvent) => {
  //     if (
  //       dropdownRef.current && !dropdownRef.current.contains(e.target as Node) &&
  //       clickableDivRef.current && !clickableDivRef.current.contains(e.target as Node)
  //     ) {
  //       setIsDropdownVisible(false); // Close the dropdown if clicked outside
  //     }
  //   };

  //   document.addEventListener('mousedown', handleClickOutside);

  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, []);

  const dropdownRef = useRef<any>(null);


  useEffect(() => {
    const handleClickOutsideModal = (event: any) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutsideModal);

    return () => {
      document.removeEventListener('mousedown', handleClickOutsideModal);
    };
  }, []);

  useEffect(() => {
    let tokenData: any = Cookies.get();
    let dashboardTour: any = tokenData['dashboardTour'] ?? "";
    if (dashboardTour === '') {
      let Authorization: any = tokenData['ssoToken'] ?? "";
      if (Authorization !== '') {
        const auth: any = jwt_decode(Authorization)
        if (auth?.dashboard_tour == 0) {
          setCurrentStep(0)
          setIsTourRunning(true)
        }
      }
    }

    if (loginPlanDetail != 120)
      getAddOnList()

  }, []);

  useEffect(() => {
    setNotifications(readMessages);
    setUnreadMsg(unreadMessages);
    setUnReadCount(unreadCount);
  }, [readMessages, unreadMessages, unreadCount]);

  const closeTour = () => {
    let tokenData: any = Cookies.get();
    let Authorization: any = tokenData['dashboardTour'] ?? "";
    if (Authorization == '') {
      tourAPIupdate()
    }
  }

  const tourAPIupdate = () => {
    let data = {
      "company_id": LoginUserDetails.companyId,
      "email": userEmailId,
      "dashboard_tour": 1,
      "chatbot_tour": 0,
      "dchatflow_tour": 0
    }
    Cookies.set('dashboardTour', 'Completed', 1)
    axios.post(`${config().MYACCOUNTSERVICE_URL}/worktual/ccaas_update_tour_info`, data)
      .then((res: any) => {
        // if (res.data.status_code === 200) {
        //   SetItemInStorage(LocalStorage.USER_DETAILS, JSON.stringify({ ...userTour, dashboard_tour: 1 }))
        // }
      }).catch((error: any) => { console.log(error, "error123") });
  }

  const [customerData, setCustomerData] = useState<any>(null);
  useEffect(() => {
    if (users.length === 0) {
      dispatch(getAllUsers());
    }
    const userEmail = userEmailId;
    // setTimeout(() => {
    // changeStatus(userEmail);
    // }, 1000);
  }, [users?.length, userEmailId]);

  // useEffect(() => {

  // }, [sharingStatus, annotationEnable, remoteVideoSize, JSON.stringify(sharingReducerState)])

  useEffect(() => {
    if (currentSession && currentSession.customerData) {
      let temp: any = currentSession.customerData ? isJSON(currentSession?.customerData) ? JSON.parse(currentSession?.customerData) : currentSession?.customerData : {};
      if (temp && temp.fromData) {
        let _name = temp.fromData.split("<");
        if (_name.length > 1) {
          temp.email = _name[1].slice(0, -1);
          temp.name = _name[0].trim();
        } else {
          let _name = temp.fromData.split("@");
          temp.name = _name[0].trim();
          temp.email = temp.fromData;
        }
      }
      setCustomerData(temp);
    }
  }, [currentSession])

  useEffect(() => {
    let agent = userRoleId && userRoleId.split(",").includes(ROLES.AGENT_ROLE_ID);
    let admin =
      userRoleId &&
      (userRoleId.split(",").includes(ROLES.ADMIN_ROLE_ID) ||
        userRoleId.split(",").includes(ROLES.SUB_OWNER_ROLE_ID) ||
        userRoleId.split(",").includes(ROLES.OWNER_ROLE_ID));
    let supervisor = userRoleId && userRoleId.split(",").includes(ROLES.SUPERVISOR_ROLE_ID);
    setUserType(admin ? "Admin" : supervisor ? "Supervisor" : agent ? "Agent" : "Agent");
  }, [users, agentstatusList]);

  const closeAllOpens = () => {
    dispatch(CallPopUpAgentActions.closeDialPadOnTopBar());
  };

  useEffect(() => {
    if (shortcutKeysSlice.agentTracker === true) {
      setOpen(true);
    }
    if (shortcutKeysSlice.transferOnly === true) {
      dispatch(AgentStateAction.setCurrentStatus({ status: "Transfer Only" }));
    }
    if (shortcutKeysSlice.offline === true) {
      dispatch(AgentStateAction.setCurrentStatus({ status: "Offline" }));
    }
    if (shortcutKeysSlice.readyState === true) {
      dispatch(AgentStateAction.setCurrentStatus({ status: "Ready" }));
    }
    if (shortcutKeysSlice.away === true) {
      dispatch(AgentStateAction.setCurrentStatus({ status: "Away" }));
    }
    if (shortcutKeysSlice.notReady === true) {
      dispatch(AgentStateAction.setCurrentStatus({ status: "Not Ready" }));
    }
    if (shortcutKeysSlice.busy === true) {
      dispatch(AgentStateAction.setCurrentStatus({ status: "Busy" }));
    }
    if (shortcutKeysSlice.logOut === true) {
      signOut();
    }
  }, [shortcutKeysSlice]);


  useEffect(() => {
    const host = window.location.host;
    const parts = host.split('.');
    if (parts.length > 2) {
      setCountryCode(parts[parts.length - 1]);
    }
    console.log('setCountryCode::::', parts[parts.length - 1])
  }, []);


  const changeStatus = async (email: any) => {
    const index = users.findIndex((user: any) => user?.emailId?.toLowerCase() === email?.toLowerCase());
    if (index !== -1) {
      if (!currentStatus?.statusName) {
        const presence = sessionStorage.getItem('presence')
        const currentPresence = (presence === "" || !presence) ? "Not Reaady" : presence
        // dispatch(AgentStateAction.setCurrentStatus({ status: users[index]?.statusName }));
        dispatch(AgentStateAction.setCurrentStatus({ status: currentPresence }));
        const { agentStatus } = store.getState().agentState;
        let status: any = null
        if (agentStatus?.length > 0) {
          // [status] = agentStatus.filter((i: any) => { return users[index]?.statusName?.trim() === i?.statusName?.trim() })
          [status] = agentStatus.filter((i: any) => { return currentPresence?.trim() === i?.statusName?.trim() })
        }
        let enableStatus: any = null
        if (users.length > 0) {
          [enableStatus] = users?.filter((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
        }
        console.log('presenceService 15', status, enableStatus, currentPresence);
        presenceService?.io?.emit("updatestate_backend", {
          domainId: users[index]?.domainId,
          isVoice: (enableStatus?.voice === 1 && status?.isVoice === 1) ? 1 : 0,
          isVoiceCallTransfer: status?.isVoiceCallTransfer ?? 0,
          isChat: (enableStatus?.chat === 1 && status?.isChat === 1) ? 1 : 0,
          isChatTransfer: status?.isChatTransfer ?? 0,
          isEmail: (enableStatus?.email === 1 && status?.isEmail === 1) ? 1 : 0,
          isEmailTransfer: status?.isEmailTransfer ?? 0,
          stateTime: Math.floor(Date.now() / 1000),
          // statusName: users[index]?.statusName,
          statusName: currentPresence,
          ext: users[index]?.ext,
          email: users[index]?.emailId,
          routingProfileId: users[index]?.routing_profile_id,
          userName: users[index]?.UserName,
          roleId: users[index]?.roleid,
          agentStatus: Object.keys(incomingCallDetail)?.length > 0 ? 0 : 1,
          skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
          routingMethod: enableStatus?.routingMethod ?? 0,
          inboundCall: enableStatus?.inboundCall,
          outboundCampaignCall: enableStatus?.outboundCampaignCall,
          is_outbound_campaign_specific_agent: enableStatus?.is_outbound_campaign_specific_agent
        });
      }
    }
  };
  const handleCancel = (type: any) => {
    if (type === "create") {
      setCreateModal(false);
    }
  };
  const showCreateModal = () => {
    setCreateModal(true);
  };

  const concurrentLimitUpdate = async () => {
    try {
      CoreServices.get(`/get_concurrent_chat`).then((value: any) => {
        if (value.status === 200) {
          console.log('concurrent get_concurrent_chat>>>>>', value?.data?.getConcurrentChatDataRes[0]);
          const agentOccupyDetails = isJSON(value?.data?.getConcurrentChatDataRes[0]?.agentOccupyDetails) ? JSON.parse(value?.data?.getConcurrentChatDataRes[0]?.agentOccupyDetails) : value?.data?.getConcurrentChatDataRes[0]?.agentOccupyDetails;
          console.log('concurrent get_concurrent_chat>>>>>', agentOccupyDetails);

          let val: any;
          const tempData: any = agentOccupyDetails;
          tempData.currentChatCount = { ...tempData?.currentChatCount, [LoginUserDetails?.ext]: 0 };
          val = { "agentOccupyDetails": JSON.stringify(tempData) };
          console.log('concurrent  val>>>>>', val);
          CoreServices.post(val, `/insert_update_concurrent_chat`).then((value: any) => {
            if (value.status === 200) {
              console.log('success')
            } else {
              console.log('failed');
            }
          })
        }
      });
    } catch (err) {
      console.log('err', err)
    }
  }
  const signOut = async () => {
    try {
      await concurrentLimitUpdate();
      dispatch(getAllContactListActions.reset())
      if (callDetails.length === 1) {
        EndCallfunction(incomingCallDetail);
        dispatch(CallPopUpAgentActions.reset());
      } else {
        if (callDetails.length > 1) {
          let index = _.findIndex(callDetails, (item: any) => {
            return item.guid === incomingCallDetail.guid;
          });

          if (index > -1) {
            EndCallfunction(callDetails[index]);
            dispatch(CallPopUpAgentActions.reset());
          }
        }
      }
      dispatch(CallPopUpAgentActions.closeTransfer());
      const ringer: any = document.getElementById("ringer");
      if (ringer) ringer.pause();
    } catch (err: any) { }
    dispatch(getAllContactListActions.reset())
    dispatch(ChatActions.reset());
    let updatedata = {
      isVoice: 0,
      isVoiceCallTransfer: 0,
      isChat: 0,
      isChatTransfer: 0,
      isEmail: 0,
      isEmailTransfer: 0,
      stateTime: Math.floor(Date.now() / 1000),
      statusName: "Offline",
    };
    const ringer: any = document.getElementById("ringer");
    if (ringer) ringer.pause();
    CoreServices.put(updatedata, `/update_agent_status_value/${userEmailId}`).then(async (value: any) => {
      if (value && value.data.statusCode === 200) {
        const popUpDetails: any = store.getState().callPopUpDetails;
        let { incomingCallDetail } = popUpDetails;
        const { agentStatus } = store.getState().agentState;
        const { users } = store.getState().userList;
        let status: any = null
        if (agentStatus?.length > 0) {
          [status] = agentStatus.filter((i: any) => { return "Offline" === i?.statusName?.trim() })
        }
        let enableStatus: any = null
        if (users.length > 0) {
          [enableStatus] = users?.filter((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
        }
        console.log('presenceService 8', status, enableStatus);
        presenceService?.io?.emit("updatestate_backend", {
          domainId: LoginUserDetails?.domainId,
          isVoice: (enableStatus?.voice === 1 && status?.isVoice === 1) ? 1 : 0,
          isVoiceCallTransfer: status?.isVoiceCallTransfer ?? 0,
          isChat: (enableStatus?.chat === 1 && status?.isChat === 1) ? 1 : 0,
          isChatTransfer: status?.isChatTransfer ?? 0,
          isEmail: (enableStatus?.email === 1 && status?.isEmail === 1) ? 1 : 0,
          isEmailTransfer: status?.isEmailTransfer ?? 0,
          stateTime: Math.floor(Date.now() / 1000),
          statusName: "Offline",
          ext: LoginUserDetails?.ext,
          email: LoginUserDetails?.Email,
          agentStatus: Object.keys(incomingCallDetail)?.length > 0 ? 0 : 1,
          userId: LoginCcaasUserDetails?.UserID,
          routingProfileId: LoginCcaasUserDetails?.routing_profile_id,
          roleId: LoginCcaasUserDetails?.roleid,
          skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
          routingMethod: enableStatus?.routingMethod ?? 0,
          inboundCall: enableStatus?.inboundCall,
          outboundCampaignCall: enableStatus?.outboundCampaignCall,
          is_outbound_campaign_specific_agent: enableStatus?.is_outbound_campaign_specific_agent,
          forced_presence: 0
        });
        let body: any = {
          state: status?.aid ?? 0,      // state: currentState?.statusName === 'Ready' ? 1 : currentState?.statusName === "Not Ready" ? 2 : currentState?.statusName === "Transfer Only" ? 3 : currentState?.statusName === "Away" ? 4 : currentState?.statusName === "Offline" ? 5 : currentState?.statusName === "Busy" ? 6 : null,
          timestamp: Date.now(),
        };
        await CallServices.post(body, `/create_state`).catch((err: any) => console.log(err));
        presenceService.destroy();
      }
      try {
        ReportServices.get("/get_dashboard_agent_status/0").catch((err: any) => console.log(err));
      } catch (error) {
        console.log(error)
      }
      const date = new Date();
      const uuid = GetItemFromStorage("uuid");
      // const uuid = GetItemFromStorage("uuid");
      const body = {
        logOutTimestamp: date.getTime(),
        logInSessionId: uuid,
      };
      CoreServices.put(body, `/update_login_session_history`).catch((e: any) => console.error(e));
      store.dispatch({
        type: Types.USER_LOGOUT,
      });
      callChatService.updateLogoutForCrossDomain();
      callChatService.destroy();
      Cookie.clear();
      ClearStorage();
      localStorage.clear();
      sessionStorage.clear();
      dispatch(
        shortcutKeyActions.propsValue({
          logOut: false,
        }),

      );
      dispatch({ type: `${LOGIN_USER}/logout` });
      navigate("/login", { replace: true });
    });

  };

  useEffect(() => {
    setBadgeFlag(true);
    if (notificationList.length === 0) {
      setEmptynotify(false);
    } else {
      let sortedValue = _(notificationList)
        .groupBy((elem) => elem.date)
        .map((data, notifyDate) => ({ notifyDate, data }))
        .value();
      setEmptynotify(true);
      setTempNotifcation(notificationList);
      setNotifications(sortedValue);
      setBadgeFlag(false);
      countFunction();
    }
  }, [notificationList]);

  const countFunction = () => {
    let countvalue = 0;
    tempNotification.map((item: any) => {
      if (item.markasread === 1) {
        countvalue += 1;
      }
    });
    setCount(countvalue);
  };

  useEffect(() => {
    notificationGet()
  }, [notificationRefreshData?.refreshNotification]);

  const notificationGet = () => {
    const data: any = {
      timeStamp: 0,
      limit,
      offset: 0,
    };

    CallServices.post(data, '/get_notification')
      .then((res: any) => {
        if (res && res.data && res.data.statusCode === 200) {
          const read = Array.isArray(res?.data?.read) ? res?.data?.read : [];
          const unRead = res?.data?.unRead || [];
          const unReadCount = res?.data?.unReadCount[0] || 0;
          const totalCount = res?.data?.readCount || 0;

          // Append new data to the existing notifications
          setNotifications(read);
          setUnreadMsg(unRead);
          setUnReadCount(unReadCount);
          setTotalCount(totalCount);
          dispatch(setCallNotification(false));
        }
      })
      .catch((error) => {
        console.error('Error fetching notifications:', error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const getnotificationData = (newOffset: number = 0) => {
    if (notifications.length === totalCount[0]?.totalCount) {
      return
    }
    // Prevent multiple calls during loading or when no more data is available
    if (isLoading || !hasMoreData) return;

    setIsLoading(true);

    const data: any = {
      timeStamp: 0,
      limit,
      offset: newOffset,
    };

    CallServices.post(data, '/get_notification')
      .then((res: any) => {
        if (res && res.data && res.data.statusCode === 200) {
          const read = Array.isArray(res?.data?.read) ? res?.data?.read : [];
          const unRead = res?.data?.unRead || [];
          const unReadCount = res?.data?.unReadCount[0] || 0;
          const totalCount = res?.data?.readCount || 0;

          // Append new data to the existing notifications
          setNotifications((prev: any) => [...prev, ...read]);
          setUnreadMsg((prev: any) => [...prev, ...unRead]);
          setUnReadCount(unReadCount);
          setTotalCount(totalCount);
          dispatch(setCallNotification(false));
        }
      })
      .catch((error) => {
        console.error('Error fetching notifications:', error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleScroll = (e: any) => {
    const element = e.target;
    const nearBottom =
      element.scrollHeight - Math.round(element.scrollTop + element.clientHeight) <= 50;
    if (nearBottom && !isLoading && hasMoreData) {
      const newOffset = offset + 1; // Adjust `limit` based on backend pagination
      setOffset(newOffset); // Update the offset state
      getnotificationData(newOffset); // Fetch new data
    }
  };

  const updateMarkAsRead = async (data: any) => {
    const restrictedTypes = [
      'customerBlockRequest',
      'customerDNDRequest',
      'customerBlock',
      'customerReject',
      'acceptDND',
      'rejectDND'
    ];

    if(data.type == 'User Anger Reported'){
        // skip flow will defined by BA
    } else if (restrictedTypes.includes(data.type)) {
      if (['customerBlockRequest', 'customerDNDRequest'].includes(data.type)) {
        let tab = data.type === "customerBlockRequest" ? '1' : '2'
        navigate(`/restrictedcontacts?tab=${tab}&coid=${data.coid}`)
      }
    } else if (data.type !== 'missed' && data.type !== 'Wrong disposition update') {
      navigate('/AllActivity', { state: { showTabTwo: true, notification: true } });
    } else {
      navigate('/allactivity', { state: { notification: true } })
    }

    if (data.markAsRead === 1) {
      return
    }
    const body = { nId: data?.nId };
    try {
      const res = await CallServices.post(body, "/update_markasread");
      console.log("Marked as read:", res);
      if (res.data.result[0]?.errcode === 0) {
        notificationGet()
        console.log('api calles')
      }

    } catch (error) {
      console.error("Error marking as read:", error);
    }
  };

  const updateMarkAsReadAll = async () => {
    try {

      const res = await CallServices.post({}, "/update_markasread_all");
      console.log("Marked all as read:", res);
      if (res.data.result[0]?.errcode === 0) {
        notificationGet()
      }
    } catch (error) {
      console.error("Error marking all as read:", error);
    }
  };

  const mapnotificationDetails = (data: any) => {
    let notificationCount = 0;
    const mappedData = data.map((resultData: any) => {
      // Extracting all relevant fields from the API response for each notification
      return {
        id: resultData.uuid,
        type: resultData.type,
        message: resultData.notificationMsg,
        markAsRead: resultData.markAsRead,
        date: moment(resultData.timestamp).format("DD:MMM"),
        time: moment(resultData.timestamp).format("hh:mm a"),
        channelType: resultData.channelType,
        coid: resultData.coid,
        customerValue: resultData.customerValue,
        customerName: resultData.customerName,
        primaryPhoneNumber: resultData.primaryPhoneNumber,
        createdAt: resultData.createdAt,
        updatedAt: resultData.updatedAt,
      };
    });

    // Counting unread notifications
    notificationCount = mappedData.filter((item: any) => item.markAsRead === 1).length;

    setTempNotifcation(mappedData);

    // Grouping notifications by date for further processing
    const sortedValue = _(mappedData)
      .groupBy((elem) => elem.date)
      .map((data, notifyDate) => ({ notifyDate, data }))
      .value();

    setCount(notificationCount);
    dispatch(setNotification({ notificationList: mappedData }));

    return sortedValue;
  };

  //For api optimization purpose
  // useEffect(() => {
  //   // CallServices.get("/get_all_queue_wait_time").then((resp: any) => {
  //   //   dispatch(
  //   //     queueTrackerActions.queueTrackerData({
  //   //       queueTrackerData: resp.data.getAllQueueList,
  //   //     })
  //   //   );
  //   // });

  //   // CoreServices.get(`/get_all_user_list`).then((resp: any) => {
  //   //   console.log("mainpagee23123")
  //   //   let dataValue: any = "";
  //   //   if (userRoleId != ROLES.AGENT_ROLE_ID) {
  //   //     dataValue = resp.data.getAllUserList;
  //   //     let result = MapAgentTrackerData(dataValue, userRoleId?.toString());
  //   //     dispatch(
  //   //       agentTrackerActions.updateAgentTrackerData({
  //   //         agentTrackerData: result,
  //   //       })
  //   //     );
  //   //   }
  //   //   dispatch(
  //   //     agentTrackerActions.updateAgentList({
  //   //       agentList: resp.data.getAllUserList,
  //   //     })
  //   //   );
  //   // });
  // }, []);

  const getAddOnList = async () => {
    try {
      const res = await axios.post(`${config().MYACCOUNTSERVICE_URL}/worktual/get_all_addon_list`, { 'company_id': LoginUserDetails.companyId });
      if (res?.data?.status_code === 200 && res?.data?.users[0]?.length > 0) {
        let booking = res?.data?.users[0].filter((row: any) => row?.addon_feature_name === 'Appointment Booking' && row?.isPurchased === 1);
        let email = res?.data?.users[0].filter((row: any) => row?.addon_feature_name === 'Email Marketing' && row?.isPurchased === 1);
        setEmailApointmentAddOn({ email: email?.length > 0 ? true : false, booking: booking?.length > 0 ? true : false })
      } else {
        setEmailApointmentAddOn({ email: false, booking: false })
      }
    } catch (error) {
      setEmailApointmentAddOn({ email: false, booking: false })
      console.log(error)
    }
  }
  const statusMenuListCpy = statusMenuList.filter((i: any) => !(loginPlanDetail === 32 && i.statusName === "Transfer Only"))
  const menu = (
    <Menu
      items={statusMenuListCpy?.map((list: any) => {
        let restictStatus = ["Away", "Busy", "Offline", currentStatus?.statusName]
        return {
          label: (
            <span
              onClick={() => !restictStatus.includes(list.statusName) && doSelectTheAgentStatus(list)} // Only trigger onClick if not disabled
              className={currentStatus.statusName !== list.statusName ? ` ${styles.statusList}` : `${styles.active} ${styles.statusList}`}
              style={restictStatus.includes(list.statusName) ? { cursor: 'not-allowed', color: '#ccc' } : {}}
            >
              {["Not Ready", "Ready", "Transfer Only", "Away", "Busy", "Offline"].includes(list.statusName) ? (
                <span
                  className={
                    list.statusName === "Not Ready"
                      ? `${styles.notReady} ${styles.whiteDot}`
                      : list.statusName === "Ready"
                        ? `${styles.ready} ${styles.whiteDot}`
                        : list.statusName === "Transfer Only"
                          ? `${styles.transferOnly} ${styles.whiteDot}`
                          : list.statusName === "Busy"
                            ? `${styles.busy} ${styles.whiteDot}`
                            : list.statusName === "Away"
                              ? `${styles.break} ${styles.whiteDot}`
                              : `${styles.offline} ${styles.whiteDot}`
                  }
                ></span>
              ) : (
                <span style={{ backgroundColor: list?.colorCode }} className={styles.whiteDot}></span>
              )}
              {list.statusName}
            </span>
          ),
          key: list.aid,
        };
      })}
    />
  );

  const openDialPad = async () => {
    setResetTrigger((prev) => !prev); // Toggle reset trigger
    // if (roomData.sessionList?.length === 0) {
    dispatch(CallPopUpAgentActions.setCalling())
    // }
    if (callDetails?.length === 0) {
      dispatch(
        CallPopUpAgentActions.DialPadChanges({
          isDialPadOpen: !isDialPadOpen,
          isCalling: false,
          isTransfer: false,
          isTransferSuccess: false,
          isMergeButton: false,
          isTransferButton: false,
        })
      );
      dispatch(CallPopUpAgentActions.setNumber(''));
    } else {
      // dispatch(
      //   CallPopUpAgentActions.openCalledDialPad({
      //     isMergeButton: true,
      //     isTransferButton: true,
      //     isCalling: !isCalling,
      //   })
      // );
      callDetails.map((list: any) => {
        if (list?.isTransfer === 'Transfer' && list?.callStatus === 'accepted' && list?.callType !== 'conCall') {
          dispatch(
            CallPopUpAgentActions.openCalledDialPad({
              isMergeButton: true,
              isTransferButton: true,
              isCalling: !isCalling,
            })
          );
        } else {

          dispatch(
            CallPopUpAgentActions.closeDialPad())
          dispatch(
            CallPopUpAgentActions.openCalledDialPad({
              isMergeButton: false,
              isTransferButton: false,
              isCalling: !isCalling,

            })
          );
        }
      })
      dispatch(
        CallPopUpAgentActions.setIncomingCallDetails({
          status: !status,
          incomingCallDetail: incomingCallDetail,
        })
      );
    }
  };

  const doSelectTheAgentStatus = useCallback(async (currentState: any) => {
    try {
      SetItemInStorage("WORK_STATUS_COLOR", currentState?.colorCode);
      difference();
      const popUpDetails: any = store.getState().callPopUpDetails;
      let { incomingCallDetail } = popUpDetails;
      const LoginCcaasUserDetails: any = GetItemFromStorage('LOGIN_USER_CCAAS_DETAILS');
      const { agentStatus } = store.getState().agentState;
      const { users } = store.getState().userList;
      const callSession = roomData?.sessionList?.some((data: any) => data?.channeltype === "Call")
      let status: any = null
      if (agentStatus?.length > 0) {
        [status] = agentStatus.filter((i: any) => { return currentState?.statusName?.trim() === i?.statusName?.trim() })
      }
      let enableStatus: any = null
      if (users.length > 0) {
        [enableStatus] = users?.filter((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
      }
      console.log('presenceService 9', status, enableStatus, "incomingCallDetail", incomingCallDetail, "callSession", callSession);
      if (Object.keys(popUpDetails?.incomingCallDetail ?? {})?.length === 0 && !callSession) {
        console.log("doSelectTheAgentStatus for clearIncomingCallInfo details:")
        dispatch(outboundCampaignSliceAction.clearIncomingCallInfo());
      }

      sessionStorage.setItem('presence', currentState.statusName)
      presenceService?.io?.emit("updatestate_backend", {
        domainId: LoginUserDetails?.domainId,
        isVoice: (enableStatus?.voice === 1 && status?.isVoice === 1 && (incomingCallDetail ? Object.keys(incomingCallDetail).length : 0) === 0) ? 1 : 0,
        isVoiceCallTransfer: status?.isVoiceCallTransfer ?? 0,
        isChat: (enableStatus?.chat === 1 && status?.isChat === 1) ? 1 : 0,
        isChatTransfer: status?.isChatTransfer ?? 0,
        isEmail: (enableStatus?.email === 1 && status?.isEmail === 1) ? 1 : 0,
        isEmailTransfer: status?.isEmailTransfer ?? 0,
        stateTime: Math.floor(Date.now() / 1000),
        statusName: currentState.statusName,
        ext: LoginUserDetails?.ext,
        email: LoginUserDetails?.Email,
        userId: LoginCcaasUserDetails?.UserID,
        routingProfileId: LoginCcaasUserDetails?.routing_profile_id,
        userName: LoginCcaasUserDetails?.UserName,
        roleId: LoginCcaasUserDetails?.roleid,
        agentStatus: Object.keys(incomingCallDetail)?.length > 0 ? 0 : 1,
        skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
        routingMethod: enableStatus?.routingMethod ?? 0,
        inboundCall: enableStatus?.inboundCall,
        outboundCampaignCall: enableStatus?.outboundCampaignCall,
is_outbound_campaign_specific_agent: enableStatus?.is_outbound_campaign_specific_agent,
        forced_presence: 0

      });
      let data = {
        ext: LoginUserDetails?.ext,
        domainId: LoginUserDetails?.domainId
      };
      callChatService.io.emit("agent_ready_for_queue_users", data);
      let body: any = {
        state: status?.aid ?? 0,
        timestamp: Date.now(),
      };

      try {
        await CallServices.post(body, `/create_state`);
        await ReportServices.get("/get_dashboard_agent_status/0")
        WhatsappService.post(data, `/send_agent_status_queue`);
        SocialmediaServices.post(data, `/send_agent_status_queue_facebook`);
        SocialmediaServices.post(data, `/send_agent_status_queue_instagram`);
      } catch (error) {
        console.log("API error", error)
      }
    } catch (error) {
      console.log('doSelectTheAgentStatus error', error)
    }
  }, []);

  const handleLanguage = (e: any) => {
    switch (e) {
      case "nl": {
        return setLanguage("Dutch");
      }
      case "en": {
        return setLanguage("English");
      }
      case "de": {
        return setLanguage("German");
      }
      case "fr": {
        return setLanguage("French");
      }
      case "gr": {
        return setLanguage("Greek");
      }

      default: {
        return null;
      }
    }
  };

  const navigateToShortkeys = () => {
    setOpenProfile(false)
    navigate("/shortcutkeys");
  };
  const helppage = () => {
    setOpenProfile(false)
    productid === "1" ? window.open('https://worktual.co.uk/faq/?id=contactcenter', '_blank')
      : productid === "15" ? window.open('https://worktual.co.uk/faq/?id=chatbox', '_blank') :
        window.open('https://worktual.co.uk/faq/', '_blank');
  }

  const handleMouseOverReports = () => {
    if (!forceCloseSideBarOverLayReports) {
      dispatch(sidebarActions.sideBarOverlayReports({ sideBarOverlayReports: true }));
    } else {
      dispatch(sidebarActions.sideBarOverlayReports({ sideBarOverlayReports: false }));
      dispatch(
        sidebarActions.sideBarOverlayCloseReports({
          forceCloseSideBarOverLayReports: false,
        })
      );
    }
  };

  const handleMouseOverSettings = () => {
    if (!forceCloseSideBarOverLaySettings) {
      dispatch(sidebarActions.sideBarOverlaySettings({ sideBarOverlaySettings: true }));
    } else {
      dispatch(sidebarActions.sideBarOverlaySettings({ sideBarOverlaySettings: false }));
      dispatch(
        sidebarActions.sideBarOverlayCloseSettings({
          forceCloseSideBarOverLaySettings: false,
        })
      );
    }
  };
  const handleMouseOverContacts = () => {
    if (!forceCloseSideBarOverLayContacts) {
      dispatch(sidebarActions.sideBarOverlayContacts({ sideBarOverlayContacts: true }));
    } else {
      dispatch(sidebarActions.sideBarOverlayContacts({ sideBarOverlayContacts: false }));
      dispatch(
        sidebarActions.sideBarOverlayCloseContacts({
          forceCloseSideBarOverLayContacts: false,
        })
      );
    }
  };
  const handleMouseOutReports = () => {
    dispatch(sidebarActions.sideBarOverlayReports({ sideBarOverlayReports: false }));
  };
  const handleMouseOutSettings = () => {
    dispatch(sidebarActions.sideBarOverlaySettings({ sideBarOverlaySettings: false }));
  };
  const handleMouseOutContacts = () => {
    dispatch(sidebarActions.sideBarOverlayContacts({ sideBarOverlayContacts: false }));
  };
  const doCloseSettings = () => {
    dispatch(sidebarActions.contactsMenu({ contactsMenuValue: "" }));
    dispatch(sidebarActions.reportsMenu({ reportsMenuValue: "" }));
    dispatch(
      sidebarActions.sideBarOverlayCloseSettings({
        forceCloseSideBarOverLaySettings: true,
      })
    );
  };
  const doCloseContacts = () => {
    dispatch(sidebarActions.settingsMenu({ settingsMenuValue: "" }));
    dispatch(
      sidebarActions.sideBarOverlayCloseContacts({
        forceCloseSideBarOverLayContacts: true,
      })
    );
    dispatch(sidebarActions.sideBarOverlayContacts({ sideBarOverlayContacts: false }));
    dispatch(
      sidebarActions.sideBarOverlayCloseSettings({
        forceCloseSideBarOverLaySettings: false,
      })
    );
  };

  const doCloseReports = () => {
    dispatch(sidebarActions.settingsMenu({ settingsMenuValue: "" }));
    dispatch(
      sidebarActions.sideBarOverlayCloseContacts({
        forceCloseSideBarOverLayContacts: true,
      })
    );
    dispatch(sidebarActions.sideBarOverlayContacts({ sideBarOverlayContacts: false }));
    dispatch(
      sidebarActions.sideBarOverlayCloseSettings({
        forceCloseSideBarOverLaySettings: false,
      })
    );
  };

  const CurrentUser = useMemo(() => {
    let d = users?.find((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
    return d ?? {}
  }, [users, LoginCcaasUserDetails?.emailId])

  const content = (
    <div className={styles.logoutArea} ref={contentRef}>
      <div className={styles.profileAreaPopover}>
        {/* <div className={`${GetItemFromStorage("getRandomColor3")}`}>
          <Avatar>{LoginCcaasUserDetails?.UserName?.charAt(0).toUpperCase()}</Avatar>
        </div> */}
        {!profileImage
          ? <div className={`${GetItemFromStorage("getRandomColor3")} eleventh-step eigth-step3 tenth-step`} ref={profile}>
            {LoginCcaasUserDetails?.UserName?.charAt(0)?.toUpperCase()}
          </div> 
          :
          <div ref={profile}>
            <Avatar
              className="topheaderavatar eleventh-step eigth-step3 tenth-step"
              size={28}
               src={profileImage}
            >
            </Avatar>
          </div>
        }
        <div className={styles.userDetails}>
          <span className={styles.title1}>{LoginCcaasUserDetails?.UserName}</span>
          <span className={styles.title2}>{LoginCcaasUserDetails?.emailId}</span>
        </div>
      </div>
      <ul>
        {/* <li onClick={() => {
          setOpenProfile(false)
          if (process.env.REACT_APP_ENV === 'production') {
            window.location.href = "https://myaccount.worktual.co.uk/";
            switch (countryCode) {
              case 'uk': {
                window.location.href = "https://myaccount.worktual.co.uk/";
                break;
              }
              case 'in': {
                window.location.href = "https://myaccount.worktual.in/";
                break;
              }
              case 'com': {
                window.location.href = "https://myaccount.worktual.com/";
                break;
              }
            }

          } else if (process.env.REACT_APP_ENV === 'qa') {
            switch (countryCode) {
              case 'uk': {
                window.location.href = "https://qa-myaccount.worktual.co.uk/";
                break;
              }
              case 'in': {
                window.location.href = "https://qa-myaccount.worktual.in/";
                break;
              }
              case 'com': {
                window.location.href = "https://qa-myaccount.worktual.com/";
                break;
              }
            }
          } else {
            switch (countryCode) {
              case 'uk': {
                window.location.href = "https://qa-myaccount.worktual.co.uk/";
                break;
              }
              case 'in': {
                window.location.href = "https://qa-myaccount.worktual.in";
                break;
              }
              case 'com': {
                window.location.href = "https://qa-myaccount.worktual.com";
                break;
              }
            }
          }
        }}>View profile</li> */}
        {(productid != 17) && hassAccess('KeyboardShortcuts') && (<li onClick={navigateToShortkeys}><a >Keyboard shortcuts</a></li>
        )}
        <li onClick={helppage}><a >Help</a></li>
        <li className={styles.logout} onClick={signOut}><a >Sign Out</a></li>
      </ul>

      {(process.env.REACT_APP_ENV === "umn" || process.env.REACT_APP_ENV === "qa") && <p style={{ padding: "12px 16px", marginBottom: "0px", cursor: "pointer" }} onClick={() => { serDomainUrl(true); setOpenProfile(false) }}>URL</p>}
    </div>
  );

  const showDrawer = () => {
    setOpen(true);
    dispatch(CallPopUpAgentActions.closeDialPadOnTopBar());
  };

  const DrawerControl = (open: any) => {
    setOpen(open);
  };

  const onClose = () => {
    setOpen(false);
    dispatch(
      shortcutKeyActions.propsValue({
        agentTracker: false,
      })
    );
  };

  const doOpen = () => {
    setFull(!full);
    setCollapsed(!collapsed);
    doDispatch(!full);
  };

  const doDispatch = (full: boolean) => {
    if (full) {
      dispatch(sidebarActions.sideBarOverlayCollapse({ Menucollapse: true }));
    } else {
      dispatch(sidebarActions.sideBarOverlayCollapse({ Menucollapse: false }));
    }
  };

  const difference = () => {
    let loginTime = parseInt(stateChange);

    let presenttime = parseInt(moment().format("x")) / 1000;

    let diff = presenttime - loginTime;

    setTime(diff);
  };

  const handleMarkAsRead = (item: any) => {
    CallServices.put({ uuid: item }, "/update_markasread").then((res: any) => {
      if (res && res.data.statusCode === 200) {
        let notificationscopy: any = tempNotification.map((eachnotification: any) => {
          if (eachnotification.id === item.id) {
            if (item.markasread === 1 && eachnotification.markasread === 1) {
              setCount(count - 1);
              return { ...item, markasread: 0 };
            } else {
              setCount(count);
              return { ...item };
            }
          } else {
            return { ...eachnotification };
          }
        });
        setTempNotifcation(notificationscopy);
        let sortedValue = _(notificationscopy)
          .groupBy((elem) => elem.date)
          .map((data, notifyDate) => ({ notifyDate, data }))
          .value();
        setNotifications(sortedValue);
        dispatch(
          setNotification({
            notificationList: notificationscopy,
          })
        );
      }
    });
    setBadgeFlag(true);

    if (item.type === "Customer Block Request") {
      setBadgeFlag(false);
      navigate("/BlockRequestDetails");
    }
    if (item.type === "Customer DND Request") {
      setBadgeFlag(false);
      navigate("/DNDRequestDetails");
    }
    if (item.type === "Call back assigned by supervisor") {
      setBadgeFlag(false);
      // navigate("/myactivity");
    }
    if (item.type === "Admin added new user") {
      setBadgeFlag(false);
      navigate("/usermanagement");
    }
    if (item.type === "Admin purchased new number") {
      setBadgeFlag(false);
      navigate("/contactcenternumber");
    }
  };

  const handleMaekAllRead = () => {
    setBadgeFlag(true);
    CallServices.put({ uuid: "All" }, "/update_markasread").then((res: any) => {
      if (res && res.data.statusCode === 200) {
        setCount(0);
        setBadgeFlag(false);
        let notificationscopy: any = tempNotification.map((item: any) => {
          return { ...item, markasread: 0 };
        });
        setTempNotifcation(notificationscopy);
        let sortedValue = _(notificationscopy)
          .groupBy((elem) => elem.date)
          .map((data, notifyDate) => ({ notifyDate, data }))
          .value();
        setNotifications(sortedValue);
        setEmptynotify(true);
        dispatch(
          setNotification({
            notificationList: notificationscopy,
          })
        );
      }
    });
  };

  const formatTime = (timestamp: number) => {
    const date = new Date(timestamp);
    return date.toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });
  };

  const closePopover = () => {
    dispatch(shortcutKeyActions.setIsBellModalOpen(false));
  };


  const content1 = (
    <div className={styles.notificationtitle}>
      <div className={styles.notificationheader}>
        <span className={styles.nottitle}>Notification</span>
        <div className={styles.notifyclose}>
          {unReadCount?.unReadCount > 0 && <span className={styles.markreadtxt} onClick={updateMarkAsReadAll}>Mark All Read</span>}
          <img src={closeicon} alt="" onClick={closePopover} className={styles.closeicons} />
        </div>
      </div>
      {/* {emptynotify ? (
        <div className={styles.notificationheader}>
          <span className={styles.nottitle}>Notification</span>
          <span className={styles.markreadtxt} onClick={handleMaekAllRead}>Mark All Read</span>
        </div>
      ) : (
        <div className={styles.emptynotification}>
          <img src={EmptyNotify} alt="" className="Notification" />
        </div>
      )}  */}

      <div className={styles.notificationContent}>
        <Tabs defaultActiveKey="1" className='queueTab noLeft notificationtab'>
          <Tabs.TabPane tab="All" key="1">
            <div className={styles.notificationcontbox} onScroll={handleScroll}>
              {/* {notifications?.length > 0 ? (
                notifications.map((allData: any, index: number) => (
                  <div
                    key={allData.nId}
                    onClick={() => updateMarkAsRead(allData)}
                    className={styles.notificationblock}
                  >
                    <div className={styles.leftend}>
                      <div className={styles.avatorbox}>
                        <div className={styles.profileArea}>
                          <div
                            className={`${GetItemFromStorage("getRandomColor3")}`}
                          >
                            <Avatar
                              className="topheaderavatar eleventh-step eigth-step3 tenth-step"
                              size={28}
                            >
                              {allData?.customerName?.trim() != "" ? allData.customerName?.trim()?.charAt(0).toUpperCase() : "N"}
                            </Avatar>
                          </div>
                        </div>
                      </div>

                      <div className={styles.message}>
                        {allData.channelType === "Chat" ? (
                          allData.type === "Chat CALLBACK" ? (
                            `${allData.notificationMsg} ${allData.customerName}`
                          ) : (
                            allData?.notificationMsg
                          )
                        ) : allData?.type === "Outbound campaign" ?
                          // (allData?.notificationMsg)
                          <div dangerouslySetInnerHTML={{ __html: allData?.notificationMsg }} />
                          : ['customerBlockRequest', 'customerBlock', 'customerReject', 'customerDNDRequest', 'acceptDND', 'rejectDND'].includes(allData?.type)
                            ? <>{allData?.notificationMsg}</>
                            :
                            (
                              <>
                                {allData?.type} from{" "}
                                <span className={styles.namebold}>{allData?.customerName?.trim() != "" ? allData?.customerName?.trim() : "New Customer"}</span>{" "}
                                {allData?.customerValue}
                              </>
                            )}
                      </div>
                    </div>

                    <div className={styles.rightend}>
                      <div
                        className={`${styles.stsdot} ${allData?.markAsRead === 1
                          ? styles.read
                          : styles.unread
                          }`}
                      ></div>
                      <span className={styles.timingtxt}>
                        {formatTime(allData.timestamp)}
                      </span>
                    </div>
                  </div>
                ))
              )
                : (
                  <div className={styles.emptynotification}>
                    <img
                      src={EmptyNotify}
                      alt="No Notifications"
                      className="Notification"
                    />
                    <p>No notifications available</p>
                  </div>
                )} */}
              {notifications?.length > 0 ? (
                (() => {

                  const groupedNotifications = notifications?.reduce((acc : any, item : any) => {
                    const dateKey = moment(item?.createdAt)?.format("YYYY-MM-DD");
                  
                    if (!acc[dateKey]) acc[dateKey] = [];
                    acc[dateKey]?.push(item);
                  
                    return acc;
                  }, {});
                  
                  const sortedDateKeys = Object.keys(groupedNotifications).sort(
                    (a, b) => moment(b).valueOf() - moment(a).valueOf()
                  );
                  
                  return sortedDateKeys.map((dateKey: string) => {
                    const date = moment(dateKey, "YYYY-MM-DD");

                    return(
                    <React.Fragment key={dateKey}>
                        <h6>
                          {date?.isSame(moment(), "day")
                            ? "Today"
                            : date?.isSame(moment().subtract(1, "day"), "day")
                              ? "Yesterday"
                              : date?.format("DD-MM-YYYY")}
                        </h6>

                      {groupedNotifications[dateKey].map((allData: any) => (
                        <div
                          key={allData.nId}
                          onClick={() => updateMarkAsRead(allData)}
                          className={styles.notificationblock}
                        >
                          {/* Left Section */}
                          <div className={styles.leftend}>
                            <div className={styles.avatorbox}>
                              <div className={styles.profileArea}>
                                <div className={`${GetItemFromStorage("getRandomColor3")}`}>
                                  <Avatar className="topheaderavatar" size={28}>
                                    {allData?.customerName?.trim()
                                      ? allData.customerName.trim().charAt(0).toUpperCase()
                                      : "N"}
                                  </Avatar>
                                </div>
                              </div>
                            </div>

                            <div className={styles.message}>
                              {allData.channelType === "Chat" ? (
                                allData.type === "Chat CALLBACK" ? (
                                  `${allData.notificationMsg} ${allData.customerName}`
                                ) : (
                                  allData.notificationMsg
                                )
                              ) : allData.type === "Outbound campaign" ? (
                                <div
                                  dangerouslySetInnerHTML={{ __html: allData.notificationMsg }}
                                />
                              ) : ['customerBlockRequest', 'customerBlock', 'customerReject', 'customerDNDRequest', 'acceptDND', 'rejectDND', "User Anger Reported"].includes(allData.type) ? (
                                allData.notificationMsg
                              ) : (
                                <>
                                  {allData.type} from{" "}
                                  <span className={styles.namebold}>
                                    {allData.customerName?.trim() || "New Customer"}
                                  </span>{" "}
                                  {allData.customerValue}
                                </>
                              )}
                            </div>
                          </div>

                          <div className={styles.rightend}>
                            <div
                              className={`${styles.stsdot} ${allData?.markAsRead === 1
                                ? styles.read
                                : styles.unread
                                }`}
                            ></div>
                            <span className={styles.timingtxt}>
                              {formatTime(allData.timestamp)}
                            </span>
                          </div>
                        </div>
                      ))}
                    </React.Fragment>
                  )});
                })()
              ) : (
                <div className={styles.emptynotification}>
                  <img src={EmptyNotify} alt="No Notifications" className="Notification" />
                  <p>No notifications available</p>
                </div>
              )}
            </div>
            {/* <div className={styles.emptynotification}>
                  <img src={EmptyNotify} alt="" className="Notification" />
                </div> */}
          </Tabs.TabPane>

          <Tabs.TabPane tab={
            <div className={styles.unreadmsggcont}>
              Unread
              <span
                className={unReadCount?.unReadCount > 0 ? styles.unreadCountBadge : ""}>
                {unReadCount?.unReadCount > 0 ? unReadCount.unReadCount : ""}
              </span>
            </div>
          }
            key="2">
            <div className={styles.notificationcontbox} onScroll={handleScroll}>
              {/* {unread.length > 0 ? (
                <>
                  {unread.map((notification: any) => {
                    return (
                      <div
                        key={notification.nId}
                        className={styles.notificationblock}
                        onClick={() => updateMarkAsRead(notification)}
                      >
                        <div className={styles.leftend}>
                          <div className={styles.avatorbox}>
                            <div>
                              <div className={styles.profileArea}>
                                <div className={`${GetItemFromStorage("getRandomColor3")}`}>
                                  <Avatar
                                    className="topheaderavatar eleventh-step eigth-step3 tenth-step"
                                    size={28}
                                  >
                                    {notification.customerName != "" ? notification.customerName?.charAt(0).toUpperCase() : "N"}
                                  </Avatar>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className={styles.paraa}>
                            <div className={styles.message}>
                              {notification.channelType === "Chat" ? (
                                notification.type === "Chat CALLBACK" ? (
                                  `${notification.notificationMsg} ${notification.customerName}`
                                ) : (
                                  notification?.notificationMsg
                                )
                              ) : notification?.type === "Outbound campaign" ?
                                <div dangerouslySetInnerHTML={{ __html: notification?.notificationMsg }} />
                                : (
                                  <>
                                    {notification?.type} from{" "}
                                    <span className={styles.namebold}>{notification?.customerName.trim() != "" ? notification?.customerName : "New Customer"}</span>{" "}
                                    {notification?.customerValue}
                                  </>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className={styles.rightend}>
                          <div className={styles.stsdot}></div>
                          <span className={styles.timingtxt}>
                            {formatTime(notification?.timestamp)}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </>
              ) : (
                <div className={styles.emptynotification}>
                  <div>

                    <img src={EmptyNotify} alt="" className="Notification" />
                    <p>No notifications available</p>

                  </div>
                </div>
              )} */}
              {unread.length > 0 ? (
                (() => {
                  const groupedUnread = notifications?.reduce((acc : any, item : any) => {
                    const dateKey = moment(item?.createdAt)?.format("YYYY-MM-DD");
                  
                    if (!acc[dateKey]) acc[dateKey] = [];
                    acc[dateKey]?.push(item);
                  
                    return acc;
                  }, {});
                  
                  const sortedDateKeys = Object.keys(groupedUnread).sort(
                    (a, b) => moment(b).valueOf() - moment(a).valueOf()
                  );
                  
                  return sortedDateKeys.map((dateKey: string) => {
                    const date = moment(dateKey, "YYYY-MM-DD");

                    return(
                    <React.Fragment key={dateKey}>
                      <h6>
                          {date?.isSame(moment(), "day")
                            ? "Today"
                            : date?.isSame(moment().subtract(1, "day"), "day")
                              ? "Yesterday"
                              : date?.format("DD-MM-YYYY")}
                        </h6>

                      {groupedUnread[dateKey].map((notification: any) => (
                        <div
                          key={notification.nId}
                          className={styles.notificationblock}
                          onClick={() => updateMarkAsRead(notification)}
                        >
                          <div className={styles.leftend}>
                            <div className={styles.avatorbox}>
                              <div>
                                <div className={styles.profileArea}>
                                  <div className={`${GetItemFromStorage("getRandomColor3")}`}>
                                    <Avatar
                                      className="topheaderavatar eleventh-step eigth-step3 tenth-step"
                                      size={28}
                                    >
                                      {notification.customerName?.trim()
                                        ? notification.customerName.charAt(0).toUpperCase()
                                        : "N"}
                                    </Avatar>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className={styles.paraa}>
                              <div className={styles.message}>
                                {notification.channelType === "Chat" ? (
                                  notification.type === "Chat CALLBACK" ? (
                                    `${notification.notificationMsg} ${notification.customerName}`
                                  ) : (
                                    notification.notificationMsg
                                  )
                                ) : notification.type === "Outbound campaign" ? (
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: notification.notificationMsg,
                                    }}
                                  />
                                ) : notification.type === "User Anger Reported" ? (
                                    notification.notificationMsg
                                ) : (
                                  <>
                                    {notification.type} from{" "}
                                    <span className={styles.namebold}>
                                      {notification.customerName?.trim() || "New Customer"}
                                    </span>{" "}
                                    {notification.customerValue}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className={styles.rightend}>
                            <div className={styles.stsdot}></div>
                            <span className={styles.timingtxt}>
                              {formatTime(notification.timestamp)}
                            </span>
                          </div>
                        </div>
                      ))}
                    </React.Fragment>
                  )});
                })()
              ) : (
                <div className={styles.emptynotification}>
                  <div>
                    <img src={EmptyNotify} alt="" className="Notification" />
                    <p>No notifications available</p>
                  </div>
                </div>
              )}

            </div>

          </Tabs.TabPane>
        </Tabs>
        {/* <div className={styles.left}>
          <ul>
            <li>
              {notifications?.map((item: any) => {
                return (
                  <Item key={item.id}>
                    <div className={styles.notificationtop}>
                      {item.notifyDate == moment(new Date()).format("DD:MMM") ? (
                        <h6>Today</h6>
                      ) : item.notifyDate == moment().subtract(1, "days").format("DD:MMM") ? (
                        <h6>Yesterday</h6>
                      ) : (
                        <h6>{item.notifyDate}</h6>
                      )}
                    </div>
                    {item.data.map((elem: any, index: any) => {
                      return (
                        <Item
                          key={item.id}
                          onClick={() => {
                            handleMarkasread(elem);
                          }}
                        >
                          <div className={styles.profiledetails}>
                            {elem.type === "Customer Block Request" || elem.type === "Customer DND Request" ? (
                              <span className={styles.usericon}>{elem.message[0]}</span>
                            ) : (
                              <span className={styles.usericon}>i</span>
                            )}
                            <div className={styles.profilename}>
                              <h6>
                                {elem.message}
                                <p>{elem.time}</p>
                              </h6>
                            </div>
                            <span className={elem.markasread === 1 ? styles.away : ""}></span>
                          </div>
                        </Item>
                      );
                    })}
                  </Item>
                );
              })}
            </li>
          </ul>
        </div> */}
      </div>
    </div>
  );
  const clearAll = () => {
    CallServices.delete("/delete_notification", "").then((res: any) => {
      if (res && res.data.statusCode === 200) {
        setCount(0);
        setNotifications([]);
        setTempNotifcation([]);
        dispatch(setNotification({ notificationList: [] }));
        setEmptynotify(false);
      }
    });
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  // Function to show the modal
  const showModal = () => {
    setIsModalVisible(true);
  };

  // Function to hide the modal

  const setUrl = () => {
    SetItemInStorage(LocalStorage.WSS_URL, WSSURL);
    serDomainUrl(false);
    setWSSURL("");
  };

  useHotkeys(`Meta+S` || `Ctrl+S`, (e: any) => { });

  const switchChatSession = (data: any) => {
    try {
      setIsDropdownVisible(false)
      if (window.location.pathname !== "/chatscreenagent") {
        navigate("/chatscreenagent");
      }
      if (currentSession?.sessionId === data?.sessionId)
        return
      const textClr: any = document.getElementById('textedited');
      if (textClr !== '' && textClr !== null) {
        textClr.textContent = "";
        textClr.innerHTML = "";
        textClr.focus();
      }
      let current_data = { ...data, isInteractionView: false }
      // dispatch(ChatActions.chatAgentAssistListReset());
      // dispatch(ChatActions.chatAgentAssistReload(true))
      dispatch(ChatActions.currentChatSession(current_data));
      dispatch(ChatActions.storeCurrentSessionMsgHistory(current_data));
      dispatch(ChatActions.clearUnreadMessageCount({ sessionId: data?.sessionId }));

    } catch (error) {
      console.log('interactionOnClick switchChatSession==>>>', error)
    }
  };

  const switchChatSessionOver = (data: any) => {
    if (data.channelType !== 'Call')
      return
    if (window.location.pathname !== "/chatscreenagent") {
      navigate("/chatscreenagent");
    }
    if (currentSession?.sessionId === data?.sessionId)
      return

    let current_data = { ...data, isInteractionView: false }
    dispatch(ChatActions.chatAgentAssistListReset());
    dispatch(ChatActions.chatAgentAssistReload(true))
    dispatch(ChatActions.currentChatSession(current_data));
    dispatch(ChatActions.storeCurrentSessionMsgHistory(current_data));
  };

  const CloseSession = (sessionId: any) => {
    // navigate('/allactivity')
    let currentWindow: any = roomData.sessionList.filter((ob: any) => ob.sessionId === sessionId);
    if (currentWindow?.length && currentWindow[0]?.IsInBound >= 0 && incomingCallDetail?.sessionId === currentWindow[0]?.sessionId && incomingCallDetail?.callStatus !== undefined) {
      return notification.info({
        message: `Window can't be closed while on a call`,
        placement: "bottomLeft",
        className: "toastNotification error",
        duration: 1,
        top: 70,
      });
    } else {
      let transferCall: any = GetItemFromStorage("transfer_call");
      if (transferCall && transferCall === "1") {
        return notification.info({
          message: `Window can't be closed which will be a transferred call`,
          placement: "bottomLeft",
          className: "toastNotification error",
          duration: 1,
          top: 70,
        });
      }
      dispatch(ChatActions.chatAgentAssistReload(false))
      dispatch(ChatActions.sessionRemoveAfterEnd(sessionId));
      if (window.location.pathname === '/chatscreenagent' || window.location.pathname === '/interactionoverview') { navigate(-1) }
    }
  };

  const interactionOnClick = (data: any) => {
    try {
      setIsDropdownVisible(false)
      if (window.location.pathname !== "/chatscreenagent") {
        navigate("/chatscreenagent");
      }
      let current_data = { ...data, isInteractionView: true }
      dispatch(ChatActions.currentChatSession(current_data));
      dispatch(ChatActions.storeCurrentSessionMsgHistory(current_data));
    } catch (error) {
      console.log('switchChatSession==>>> 1 interactionOnClick error', error)
    }
  }
  const interactionMouseOver = (data: any) => {
    try {
      if (window.location.pathname !== "/chatscreenagent") {
        navigate("/chatscreenagent");
      }
      let current_data = { ...data, isInteractionView: true }
      dispatch(ChatActions.currentChatSession(current_data));
      dispatch(ChatActions.storeCurrentSessionMsgHistory(current_data));
    } catch (error) {
      console.log(error)
    }
  }

  const currentTab = (data: any) => {
    if (data?.sessionId === roomData?.currentSession?.sessionId
      // && data?.IsInBound > 0
    ) {
      return true;
    } else {
      return false;
    }
  };

  const [showDropdown, setShowDropdown] = useState(false);
  const handleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    getCallBlastAutoAnswer(dispatch)
  }, [])

  useEffect(() => {
    console.log('spanRef useEffect', currentSession);
    if (currentSession?.supervisorStatus === 'false') {
      console.log('spanRef called');
      spanRef.current.click();
    }
  }, [currentSession?.supervisorStatus]);
  const currentUserExtension = LoginCcaasUserDetails?.ext;
  const currentUserAgent = agentList.find(
    (agent: { ext: any; }) => agent.ext === currentUserExtension
  );
  const currentUserQuIds = currentUserAgent?.quId?.split(',') || [];
  //   function queueCountCal(queueTrackerData: any[], currentUserQuIds: string[]) {
  //   return queueTrackerData?.reduce((acc: number, curr: any) => {
  //     const isQueueMapped = currentUserQuIds.includes(curr?.qid?.toString());
  //     if (isQueueMapped || [3, 5].includes(LoginCcaasUserDetails?.roleid)) {
  //       const queueList = isJSON(curr?.queueList) ? JSON.parse(curr?.queueList ?? '[]') : curr?.queueList ?? [];
  //       const filteredQueue = Array.isArray(queueList)
  //         ? queueList.filter((item: any) => item.queuedTime === '0s')
  //         : [];

  //       return acc + filteredQueue.length;
  //     } else {
  //       return acc;
  //     }
  //   }, 0);
  // }

  function queueCountCal(queueTrackerData: any[], currentUserQuIds: string[]) {
    return queueTrackerData?.reduce((acc: any, curr: any) => {
      const isQueueMapped = currentUserQuIds.includes(curr?.qid?.toString());
      if (isQueueMapped || [3, 5].includes(LoginCcaasUserDetails?.roleid)) {
        return isJSON(curr?.queueList) ? acc + JSON.parse(curr?.queueList ?? '[]')?.length : acc + curr?.queueList?.length
      } else {
        return acc;
      }
    }, 0);
  }
  const queueCount = queueCountCal(queueTrackerData, currentUserQuIds)
  const agentWithoutBound_call = [] as any;
  users.forEach((user: { callTypeId: any }) => {
    if (user.callTypeId) agentWithoutBound_call.push(user);

  });

  useEffect(() => {
    try {
      if (queueCount) {
        const isQueueTrackerHasData = queueTrackerData?.reduce(
          (acc: any, curr: any) => isJSON(curr?.queueList) ? acc + JSON.parse(curr?.queueList ?? '[]')?.length : acc + curr?.queueList?.length, 0) > 0;
        dispatch(dashBoardSliceActions.setDashBoardCallQueue(isQueueTrackerHasData ? queueCount : 0));
      } else {
        dispatch(dashBoardSliceActions.setDashBoardCallQueue(0));
      }
    } catch (error) {
      dispatch(dashBoardSliceActions.setDashBoardCallQueue(0));
      console.log("dashBoardSliceActions")
    }
  }, [queueCount, queueTrackerData])

  const handleClickOutside = useCallback((event: any) => {

    if (divRef.current && divRef.current.contains(event.target)) {
      return;
    }
    if (contentRef.current && contentRef.current.contains(event.target)) {
      return;
    }
    if (appIcon.current && appIcon.current.contains(event.target)) {
      setIsVisible((prev) => !prev);
      setOpenProfile(false)
    }
    else if (profile.current && profile.current.contains(event.target)) {
      setOpenProfile((prev) => !prev)
      setIsVisible(false);
    } else if (arrowRef.current && arrowRef.current.contains(event.target)) {
      setOpenProfile((prev) => !prev);
      setIsVisible(false);
    } else {
      setIsVisible(false);
      setOpenProfile(false)
    }
  }, [openProfile, isVisible]);

  useEffect(() => {
    // Add event listener to document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (isEmpty(popUpDetails?.incomingCallDetail)) {
      try {
        const agentID = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS)?.UserID
        if (agentID) {
          CallServices.get(`/incall?agentId=${agentID}&status=1`)
        }
        console.log("callPopUpDetails?.incomingCallDetail stutas main header", popUpDetails?.incomingCallDetail)
      } catch (error) {
        console.log(error)
      }
      dispatch(outboundCampaignSliceAction.clearIncomingCallInfo());
    }

  }, [])
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      if (window.innerWidth <= 991) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);


  const [menubars, setMenubars] = useState(false);
  const menubarsclick = () => {
    setMenubars(true);
  }

  const [allSessionData, setAllSessionData] = useState<any[]>([]);


  useEffect(() => {
    if (isMobile) {
      setAllSessionData(roomData?.sessionList || []);
    } else {
      if (roomData?.sessionList?.length > 3) {
        setAllSessionData(roomData.sessionList.slice(3));
      } else {
        setAllSessionData([]);
      }
    }
    if (roomData?.sessionList?.length === 0) {
      setIsDropdownVisible(false)
    }
  }, [roomData?.sessionList, isMobile]);

  function formatElapsedTime(time: any) {
    const seconds = Math.floor(time / 1000) % 60;
    const minutes = Math.floor(time / 1000 / 60) % 60;
    const hours = Math.floor(time / 1000 / 60 / 60) % 24;
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }

  const getTransferTime = () => {
    return incomingCallDetail.callStatus === "accepted" ? incomingCallDetail.callduration :
      chatReducer?.currentSession?.callDuration ? chatReducer?.currentSession?.callDuration : currentCallDuration;
  };

  useEffect(() => {
    console.log("popUpDetails?.incomingCallDetail>>>>>>>>>>>>>>>>>>", popUpDetails?.incomingCallDetail, "callDetails", callDetails)
  }, [])

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [sessionCount, setChatSession] = useState(1)
  const [sessionCountOpen, setChatSessionOpen] = useState(false)

  useEffect(() => {
    getExpiredPlanDetails();
  }, [])

  useEffect(() => {
    setChatSessionOpen(sessionCount == 0 ? true : false)
  }, [window.location.pathname])

  const getExpiredPlanDetails = () => {
    try {
      CoreServices.get('/get_expired_plan_details').then((response: any) => {
        if (response?.data?.statusCode === 200) {
          const result = response.data?.result?.[0];
          const remainingSession = result?.remainingSession;
          const isUnilimitedChat = result?.isUnilimitedChat;
          const isSessionExpired = remainingSession == 0 && isUnilimitedChat == 0;
          setChatSession(isSessionExpired ? 0 : 1);
          setChatSessionOpen(isSessionExpired);
        } else {
          console.error("Failed to fetch data");
        }
      }).catch(error => {
        console.log("error", error);
      });
    } catch (error) {
      console.log('get_expired_plan_details', error)
    }
  }
  const navigateToPurchase = () => {
    window.open("https://myaccount.worktual.co.uk/purchasemain", "_blank");
  }

  // const allSessions = roomData?.sessionList || [];
  // const dropdownSessions = allSessions.slice(3);
  // const dropdownUnreadCount = dropdownSessions.reduce((sum: any, session: any) => {
  //   const unreadObj = unReadMessgCount?.find((item: any) => item.sessionId === session.sessionId);
  //   return sum + (unreadObj?.unReadCount || 0);
  // }, 0);

  useEffect(() => {
    try {
      (async () => {
      const src = await findLoadableImageUrl([ CurrentUser?.ProfileImage?.trim(), loginUserData?.profileImg?.trim() ]);
      setprofileImage(src);
    })();
    } catch (error) {
      console.log(error)
    }
  }, []);


  return (
    <>
      <Layout style={{ minHeight: "100vh" }}>
        <div className="notficationcommon">
          {/* <OverdueNotification /> */}
          <InternalChatNotification />
        </div>

        {/* {(sessionCountOpen && (userRoleId === ROLES.SUPERVISOR_ROLE_ID || userRoleId === ROLES.ADMIN_ROLE_ID)) && <div className='botsessionalertwrapper'>
              <div className='botsessionalert'>
                <div className='botsessionalertin'>
                  <p> 👋 To enable the bot session, please <button onClick={navigateToPurchase}>upgrade the bot session</button>  to continue using the product.</p>
                </div>
                <img className='botsessioncloseicon' src={close_icon} alt="close_icon" onClick={()=> setChatSessionOpen(false)}/>
              </div>
            </div>} */}

        <Sider trigger={null} collapsible collapsedWidth={64} collapsed={collapsed} width={230} className={
          menubars
            ? windowWidth < 1023
              ? "sideMenu sideMenumobile"
              : "sideMenu"
            : "sideMenu"
        }>
          <div className="logo">
            <img src={full ? logofull : avatar} alt="" className="brandlogo" style={{ height: full ? "36px" : "auto" }} />
            <div className="mobilemenu">
              <img src={logofull} />
              <img src={closebars} onClick={() => { setMenubars(false) }} className="menuonmobile" style={{ width: "18px", height: "18px" }} />
            </div>
          </div>
          <div className="openCollapseMenu" onClick={doOpen}>
            <span className={collapsed ? "icon__MenuOpen open" : "icon__MenuClose closed"}></span>
          </div>
          {userType === "Admin" && (
            <>
              <Joyride
                steps={JoyTour().AdminTourSteps}
                run={isTourRunning}
                stepIndex={currentStep}
                continuous={true}
                showSkipButton={true}
                disableOverlayClose={true}
                disableScrolling={true}
                styles={{
                  options: {
                    arrowColor: '#575CFF',
                  },
                }}
                tooltipComponent={(props: any) => (
                  <div className="reactTour">
                    <div>{props.step.content}</div>
                    <div className="joy_buttons">
                      {currentStep + 1 == JoyTour().AdminTourSteps?.length
                        ?
                        "" : <button className="skip" onClick={() => {
                          setIsTourRunning(false);
                          closeTour()
                        }}>Skip tour </button>}
                      <button className="nextbtn"
                        onClick={() => {
                          setCurrentStep((prevStep) => prevStep + 1);
                          closeTour()
                        }}> {currentStep + 1 == JoyTour().AdminTourSteps?.length ? 'Done' : 'Next'}</button>

                    </div>
                  </div>
                )} />
              <CustomeMenu step={currentStep} closeMenu={() => setMenubars(false)} />
            </>
          )}

          {userType === "Supervisor" && (
            <>
              <Joyride
                steps={JoyTour().SupervisorTourSteps}
                run={isTourRunning}
                stepIndex={currentStep}
                continuous={true}
                showSkipButton={true}
                disableOverlayClose={true}
                disableScrolling={true}
                styles={{
                  options: {
                    arrowColor: '#575CFF',
                  },
                }}
                tooltipComponent={(props: any) => (
                  <div className="reactTour">
                    <div>{props.step.content}</div>
                    <div className="joy_buttons">
                      {currentStep + 1 == JoyTour().SupervisorTourSteps?.length ? "" : <button className="skip" onClick={() => { setIsTourRunning(false); closeTour() }}>Skip tour </button>}
                      <button className="nextbtn"
                        onClick={() => {
                          setCurrentStep((prevStep) => prevStep + 1);
                          closeTour()
                        }}> {currentStep + 1 == JoyTour().SupervisorTourSteps?.length ? 'Done' : 'Next'}</button>

                    </div>
                  </div>
                )}
              />
              <CustomeMenu step={currentStep} closeMenu={() => setMenubars(false)} />
            </>
          )}

          {userType === "Agent" && (
            <>
              <Joyride
                steps={JoyTour().AgentTourSteps}
                run={isTourRunning}
                stepIndex={currentStep}
                continuous={true}
                showSkipButton={true}
                disableOverlayClose={true}
                disableScrolling={true}
                styles={{
                  options: {
                    arrowColor: '#575CFF',
                  },
                }}
                tooltipComponent={(props: any) => (
                  <div className="reactTour">
                    <div>{props.step.content}</div>
                    <div className="joy_buttons">
                      {currentStep + 1 == JoyTour().AgentTourSteps?.length ? '' : <button className="skip" onClick={() => { setIsTourRunning(false); closeTour() }}>Skip tour </button>}
                      <button className="nextbtn"
                        onClick={() => {
                          setCurrentStep((prevStep) => prevStep + 1);
                          closeTour()
                        }}> {currentStep + 1 == JoyTour().AgentTourSteps?.length ? 'Done' : 'Next'}</button>

                    </div>
                  </div>
                )} />
              <CustomeMenu step={currentStep} closeMenu={() => setMenubars(false)} />
            </>
          )}
        </Sider>


        <div
          className={sideBarOverlaySettings && collapsed ? "submenuOverlay show" : "submenuOverlay penone"}
          onMouseOver={handleMouseOverSettings}
          onMouseOut={handleMouseOutSettings}
          onClick={doCloseSettings}
        >
          <ul className="rootOverlayMenu">
            <li>
              <div className="menuTitle">
                <span className="icon__SettingsWhite24" /> <span className="menuname">Settings </span>
              </div>
              <div className="submenuAccordionOverlay">
                <BasicMenu />
              </div>
            </li>
          </ul>
        </div>
        <div
          className={sideBarOverlayContacts && collapsed ? "submenuOverlay show" : "submenuOverlay penone"}
          onMouseOver={handleMouseOverContacts}
          onMouseOut={handleMouseOutContacts}
          onClick={doCloseContacts}
        >
          <ul className="rootOverlayMenu">
            <li>
              <div className="menuTitle">
                <span className="icon__SettingsWhite24" /> <span className="menuname">Contacts </span>
              </div>
              <div className="submenuAccordionOverlay">
                <ContactsMenu />
              </div>
            </li>
          </ul>
        </div>
        <Layout className="site-layout tourtopcomponent" id={collapsed ? "collapsenon" : "collapseshowings"}>
          {!sharingStatus ? <div className={styles.headmenu}>
            <div className={styles.center}>

              <div className="mobilemenu">
                <img src={menubarsimg} onClick={menubarsclick} className="menuonmobile" style={{ width: "25px", height: "25px" ,cursor: 'pointer' }} />
                <img src={menumobilelogo} />
              </div>
              <div className="tobarTab scroller tobarscrolltop tobarscrolltophowing">
                <ul className="tabs group">
                  {(roomData?.sessionList?.length > 0) &&
                    roomData?.sessionList?.slice(0, 3)?.map((session: any, idx: any) => {
                      const unreadCountObj = unReadMessgCount?.find((item: any) => item?.sessionId == session?.sessionId);
                      const unreadCount = unreadCountObj?.unReadCount || 0;
                      const initials =
                        session?.calledPersonDetails?.firstName?.trim() ?
                          (session?.calledPersonDetails?.firstName?.charAt(0)?.toUpperCase() + (session?.calledPersonDetails?.lastName?.charAt(0)?.toUpperCase() || ""))
                          : 'N';

                      return (
                        <>
                          {(!session?.isInteractionView)
                            ? <li className={currentTab(session) ? "callactive active" : "callactive "}>
                              <div className={`${styles.topbarInfo} ${styles.topbarInfonew}`} onClick={() => switchChatSession(session)}
                              //  onMouseOver={() => switchChatSessionOver(session)}
                              >
                                <div className={styles.lefts}>
                                  {!session.hasOwnProperty("type") && <span className={
                                    session.channelType === "Email" ? "icon__ChatEmail24 emailic"
                                      : session.channelType === "Sms" ? "icon__sms24 smsmic"
                                        : session.channelType === "Whatsapp" ? "icon__Chatwhatsapp24 chatintric" : session.channelType === "Facebook" ? "icon__InteractionFacebook24 interbic"
                                          : session.channelType === "Instagram" ? "icon__InteractionInsta24 intergric"
                                            : session.channelType === "Voicemail" ? "icon__Voicemail36"
                                              : (session.CallHistoryId || (session?.result && session?.result[0]?.CallHistoryId && parseInt(session?.result[0]?.CallHistoryId))) ? "icon__InteractionInCallTrans24 smsmic"
                                                : (session?.ChatHistoryId || session?.channelType === 'Chat') ? "icon__InteractionMessage24 smsmic"
                                                  : ""}></span>}
                                  {session.hasOwnProperty("type") && <span><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="30" height="30" rx="10" fill="#E2A400" />
                                    <g clip-path="url(#clip0_3940_21520)">
                                      <path d="M18.1819 9.2743C17.0936 8.1878 15.5084 8.0313 14.0168 7.9944C13.332 7.976 12.7478 7.9668 12.1635 7.9668C11.5792 7.9668 10.995 7.976 10.3102 7.9944C8.82803 8.0313 7.23333 8.1878 6.14523 9.2743C5.01953 10.4071 5.02893 12.2488 5.00073 13.7039V17.3046C5.02893 18.7597 5.01953 20.6014 6.14523 21.7249C7.23333 22.8114 8.81873 22.9681 10.3102 23.0048C10.995 23.0232 11.5792 23.0325 12.1635 23.0325C12.7478 23.0325 13.332 23.0232 14.0168 23.0048C15.4989 22.9681 17.0936 22.8114 18.1819 21.7249C19.3074 20.6014 19.2982 18.7597 19.3262 17.3046C19.3357 16.706 19.345 16.0982 19.3357 15.4997C19.3357 14.9012 19.3357 14.3026 19.3262 13.6948C19.2981 12.2397 19.3074 10.3979 18.1819 9.2743Z" fill="white" />
                                      <path d="M23.8409 10.64C23.6483 10.64 23.4508 10.6944 23.2644 10.8138L19.8827 12.9803V18.019L23.2644 20.1853C23.4508 20.3047 23.6485 20.3593 23.8411 20.3593C24.4452 20.3593 24.9994 19.8232 24.9994 19.0739V11.9255C24.9994 11.1764 24.445 10.64 23.8409 10.64Z" fill="white" />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_3940_21520">
                                        <rect width="24" height="24" fill="white" transform="translate(3 3.5)" />
                                      </clipPath>
                                    </defs>
                                  </svg></span>}
                                </div>
                                <div className={styles.right}>
                                  <h5 className={`cname ${styles.ivrqueuecname}`}>
                                    <div className={styles.topinfocustomername}>
                                      <p>{session?.calledPersonDetails?.firstName?.trim() ?
                                        (session?.calledPersonDetails?.lastName ? (session?.calledPersonDetails?.firstName + " " + session?.calledPersonDetails?.lastName)
                                          : session?.calledPersonDetails?.firstName)
                                        : 'New customer'} {" "}</p>
                                      {unreadCount > 0 ? <span className={`countest ${unreadCount === 0 ? styles.counthid : ''}`}>{unreadCount}</span> : ''}
                                    </div>

                                    {(!session?.sessionEndTime
                                      && (session.channelType !== "Voicemail"
                                        && !['view', 'whisper', 'barge'].includes(session?.supervisorStatus)
                                        && currentSession?.callBack !== 1 || (session.CallBackStatus != 1 && session.CallBackStatus !== null)
                                        && ['Email', 'Sms', 'Whatsapp', 'Facebook', 'Instagram'].includes(session.channelType)
                                      )
                                    )
                                      ? <span className={`${styles.timerColor} ${unreadCount !== 0 ? styles.tabhid : ''} `}>
                                        {(session?.ChatHistoryId || session?.channelType === 'Chat')
                                          ? <Timer sessiondata={session} />
                                          : ['Email', 'Sms', 'Whatsapp', 'Facebook', 'Instagram'].includes(session.channelType)
                                            ? <Timer sessiondata={session} />
                                            : (session.CallHistoryId || session.channelType === "Call")
                                              ? (<span>{session?.callDuration && session?.callDuration.toString().includes(":")
                                                ? session?.callDuration
                                                : (!formatElapsedTime(session?.callDuration).includes("00:00:00")
                                                  ? formatElapsedTime(session?.callDuration)
                                                  : getTransferTime())}</span>)
                                              :
                                              (!['Email', 'Sms', 'Whatsapp', 'Facebook', 'Instagram'].includes(session.channelType))
                                                ? <span>
                                                  {session.callType === "outbound" && incomingCallDetail.callStatus !== "accepted"
                                                    ? incomingCallDetail.callStatus
                                                    : session.callType === "outbound" && incomingCallDetail.callStatus === "accepted"
                                                      ? incomingCallDetail.callduration :
                                                      session?.callDuration
                                                        ? session?.callDuration
                                                        : currentCallDuration}
                                                </span> : ''
                                        }</span> : ''
                                    }
                                  </h5>
                                  {/* <p>{(session?.CallHistoryId ? incomingcallDetails?.queueName : session?.queueName) ?? session?.customerDetails}</p> */}
                                  {/* {(!session?.sessionEndTime && ((session.CallHistoryId || session.channelType === "Call") || (session?.ChatHistoryId || session?.channelType === 'Chat') || ['Email', 'Sms', 'Whatsapp',  'Facebook', 'Instagram'].includes(session.channelType) )) &&
                                    <p>{(!session?.sessionEndTime && session?.callBack !== 1 || session.CallBackStatus !== 1 && session.channelType !== "Voicemail" && !['view', 'whisper', 'barge'].includes(session?.supervisorStatus)) ? `Ongoing ${session.CallHistoryId 
                                      || session.channelType === "Call" ? "Call" : session?.ChatHistoryId || session?.channelType === 'Chat' ? "Chat" : ''}` : ''}</p>} */}




                                  {(!session?.sessionEndTime
                                    && (session.channelType !== "Voicemail"
                                      && !['view', 'whisper', 'barge'].includes(session?.supervisorStatus)
                                      && currentSession?.callBack !== 1 || (session.CallBackStatus != 1 && session.CallBackStatus !== null)
                                      && ['Email', 'Sms', 'Whatsapp', 'Facebook', 'Instagram'].includes(session.channelType)
                                    )
                                  ) ?
                                    <p>{`Ongoing ${session.CallHistoryId || session.channelType === "Call" ? "Call" : session?.ChatHistoryId || session?.channelType === 'Chat' ? "Chat" : ['Email', 'Sms', 'Whatsapp', 'Facebook', 'Instagram'].includes(session.channelType) ? session.channelType : ''}`}</p>
                                    : ''
                                  }
                                </div>
                              </div>
                              {(!session?.sessionEndTime
                                && (session.channelType !== "Voicemail"
                                  && !['view', 'whisper', 'barge'].includes(session?.supervisorStatus)
                                  && currentSession?.callBack !== 1 || (session.CallBackStatus != 1 && session.CallBackStatus !== null)
                                  && ['Email', 'Sms', 'Whatsapp', 'Facebook', 'Instagram'].includes(session.channelType)
                                )
                              )
                                ? "" :
                                <span className="icon__closelight24 tabcloseicon" onClick={() => CloseSession(session?.sessionId)}></span>}
                            </li>
                            : (session?.isInteractionView ?
                              <li className={currentTab(session) ? "callactive active" : "callactive"}>

                                <div className={`${styles.topbarInfo} ${styles.topbarsessionleft}`} onClick={() => interactionOnClick(session)}>

                                  <div className={styles.lefts}>
                                    <div className={styles.chatusername}>{initials}</div>
                                    {/* {!session.hasOwnProperty("type") && <span className={
                                    session.channelType === "Email" ? "icon__ChatEmail24"
                                      : session.channelType === "Sms" ? "icon__sms24"
                                        : session.channelType === "Whatsapp" ? "icon__Chatwhatsapp24" : session.channelType === "Facebook" ? "icon__InteractionFacebook24"
                                          : session.channelType === "Instagram" ? "icon__InteractionInsta24"
                                            : session.channelType === "Voicemail" ? "icon__Voicemail36"
                                              : session.channelType === "Call" ? "icon__InteractionInCallTrans24"
                                                : (session?.ChatHistoryId || session?.channelType === 'Chat') ? "icon__InteractionMessage24"
                                                  : ""}></span>} */}
                                    {session.hasOwnProperty("type") && <span><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <rect width="30" height="30" rx="10" fill="#E2A400" />
                                      <g clip-path="url(#clip0_3940_21520)">
                                        <path d="M18.1819 9.2743C17.0936 8.1878 15.5084 8.0313 14.0168 7.9944C13.332 7.976 12.7478 7.9668 12.1635 7.9668C11.5792 7.9668 10.995 7.976 10.3102 7.9944C8.82803 8.0313 7.23333 8.1878 6.14523 9.2743C5.01953 10.4071 5.02893 12.2488 5.00073 13.7039V17.3046C5.02893 18.7597 5.01953 20.6014 6.14523 21.7249C7.23333 22.8114 8.81873 22.9681 10.3102 23.0048C10.995 23.0232 11.5792 23.0325 12.1635 23.0325C12.7478 23.0325 13.332 23.0232 14.0168 23.0048C15.4989 22.9681 17.0936 22.8114 18.1819 21.7249C19.3074 20.6014 19.2982 18.7597 19.3262 17.3046C19.3357 16.706 19.345 16.0982 19.3357 15.4997C19.3357 14.9012 19.3357 14.3026 19.3262 13.6948C19.2981 12.2397 19.3074 10.3979 18.1819 9.2743Z" fill="white" />
                                        <path d="M23.8409 10.64C23.6483 10.64 23.4508 10.6944 23.2644 10.8138L19.8827 12.9803V18.019L23.2644 20.1853C23.4508 20.3047 23.6485 20.3593 23.8411 20.3593C24.4452 20.3593 24.9994 19.8232 24.9994 19.0739V11.9255C24.9994 11.1764 24.445 10.64 23.8409 10.64Z" fill="white" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_3940_21520">
                                          <rect width="24" height="24" fill="white" transform="translate(3 3.5)" />
                                        </clipPath>
                                      </defs>
                                    </svg></span>}
                                  </div>

                                  {/* <div className={styles.lefts}>
                                    {!session.hasOwnProperty("type") && <span className={
                                      session.channelType === "Email" ? "icon__ChatEmail24"
                                        : session.channelType === "Sms" ? "icon__sms24"
                                          : session.channelType === "Whatsapp" ? "icon__Chatwhatsapp24" : session.channelType === "Facebook" ? "icon__InteractionFacebook24"
                                            : session.channelType === "Instagram" ? "icon__InteractionInsta24"
                                              : session.channelType === "Voicemail" ? "icon__Voicemail36"
                                                : session.channelType === "Call" ? "icon__InteractionInCallTrans24"
                                                  : (session?.ChatHistoryId || session?.channelType === 'Chat') ? "icon__InteractionMessage24"
                                                    : ""}></span>}
                                    {session.hasOwnProperty("type") && <span><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <rect width="30" height="30" rx="10" fill="#E2A400" />
                                      <g clip-path="url(#clip0_3940_21520)">
                                        <path d="M18.1819 9.2743C17.0936 8.1878 15.5084 8.0313 14.0168 7.9944C13.332 7.976 12.7478 7.9668 12.1635 7.9668C11.5792 7.9668 10.995 7.976 10.3102 7.9944C8.82803 8.0313 7.23333 8.1878 6.14523 9.2743C5.01953 10.4071 5.02893 12.2488 5.00073 13.7039V17.3046C5.02893 18.7597 5.01953 20.6014 6.14523 21.7249C7.23333 22.8114 8.81873 22.9681 10.3102 23.0048C10.995 23.0232 11.5792 23.0325 12.1635 23.0325C12.7478 23.0325 13.332 23.0232 14.0168 23.0048C15.4989 22.9681 17.0936 22.8114 18.1819 21.7249C19.3074 20.6014 19.2982 18.7597 19.3262 17.3046C19.3357 16.706 19.345 16.0982 19.3357 15.4997C19.3357 14.9012 19.3357 14.3026 19.3262 13.6948C19.2981 12.2397 19.3074 10.3979 18.1819 9.2743Z" fill="white" />
                                        <path d="M23.8409 10.64C23.6483 10.64 23.4508 10.6944 23.2644 10.8138L19.8827 12.9803V18.019L23.2644 20.1853C23.4508 20.3047 23.6485 20.3593 23.8411 20.3593C24.4452 20.3593 24.9994 19.8232 24.9994 19.0739V11.9255C24.9994 11.1764 24.445 10.64 23.8409 10.64Z" fill="white" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_3940_21520">
                                          <rect width="24" height="24" fill="white" transform="translate(3 3.5)" />
                                        </clipPath>
                                      </defs>
                                    </svg></span>}
                                  </div> */}

                                  {/* {<div className={styles.lefts}>
                                  <span className={
                                    session.channelType === "Email" ? "icon__ChatEmail24"
                                      : session.channelType === "Sms" ? "icon__sms24 smsmic"
                                        : session.channelType === "Whatsapp" ? "icon__Chatwhatsapp24"
                                          : session.channelType === "Facebook" ? "icon__InteractionFacebook24"
                                            : session.channelType === "Instagram" ? "icon__InteractionInsta24"
                                              // : (session.CallHistoryId || (session?.result && session?.result[0]?.CallHistoryId && parseInt(session?.result[0]?.CallHistoryId)) || session?.interactionData?.[0]?.channelType === 'Call') ? "icon__InteractionInCallTrans24"
                                              : session.channelType === "Voicemail" ? "icon__Voicemail36"
                                                : session.channelType === "Call" ? "icon__InteractionInCallTrans24 smsmic"
                                                  : (session?.ChatHistoryId && session?.ChatHistoryId != "") ? "icon__InteractionMessage24 smsmic"
                                                    : ""}></span>
                                </div>} */}
                                  <div className={`${styles.right} ${styles.rightcalledperson}`}>
                                    <h5>
                                      {session?.calledPersonDetails?.firstName?.trim() ?
                                        (session?.calledPersonDetails?.lastName ? (session?.calledPersonDetails?.firstName + " " + session?.calledPersonDetails?.lastName)
                                          : session?.calledPersonDetails?.firstName)
                                        : 'New customer'}
                                    </h5>
                                    <span className={
                                      session?.dispositionName === "Closed"
                                        ? `${styles.statusText} ${styles.closed}`
                                        : session?.dispositionName === "Unresolved"
                                          ? `${styles.statusText} ${styles.unresolved}`
                                          : session?.dispositionName === "Resolved"
                                            ? `${styles.statusText} ${styles.resolved}`
                                            : session?.dispositionName === "Follow-up"
                                              ? `${styles.statusText} ${styles.followUp}`
                                              : session?.dispositionName === "Do not contact"
                                                ? `${styles.statusText} ${styles.disconnected}`
                                                : session?.dispositionName === "Transferred"
                                                  ? `${styles.statusText} ${styles.transferred}`
                                                  : // : !val?.dispositionName
                                                  `${styles.statusText} ${styles.notFound}`
                                    }
                                    >{session?.dispositionName}</span>
                                  </div>
                                </div>
                                <span className="icon__closelight24 tabcloseicon" onClick={() => CloseSession(session?.sessionId)}></span>
                              </li> : ''
                            )
                          }
                        </>
                      );
                    }
                    )
                  }
                </ul>
                {(roomData?.sessionList?.length > 3 || (isMobile && roomData?.sessionList?.length)) ?
                  <div className={styles.centerscrollbardrop} onClick={handleDropdownList}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M7.99625 13.1838C7.59535 13.1838 7.21791 13.0276 6.93483 12.7432L2.78615 8.58222C2.59157 8.38697 2.59157 8.0707 2.78749 7.87552C2.98274 7.68093 3.29901 7.68093 3.49419 7.87685L7.64286 12.0378C7.83225 12.2272 8.16218 12.2266 8.35024 12.0378L12.4989 7.87685C12.6942 7.681 13.0104 7.681 13.2056 7.87552C13.4015 8.07077 13.4015 8.38704 13.2069 8.58222L9.05827 12.7432C8.77519 13.0276 8.39782 13.1838 7.99625 13.1838Z" fill="#757676" />
                      <path d="M7.99625 8.26262C7.59535 8.26262 7.21791 8.10642 6.93483 7.82207L2.78615 3.66107C2.59157 3.46582 2.59157 3.14955 2.78749 2.95437C2.98274 2.75978 3.29901 2.75978 3.49419 2.9557L7.64286 7.1167C7.83225 7.30609 8.16218 7.30542 8.35024 7.1167L12.4989 2.9557C12.6942 2.75985 13.0104 2.75985 13.2056 2.95437C13.4015 3.14962 13.4015 3.46589 13.2069 3.66107L9.05827 7.82207C8.77519 8.10649 8.39782 8.26262 7.99625 8.26262Z" fill="#757676" />
                    </svg>
                  </div> : ''}
                {isDropdownVisible && (
                  <div className={styles.rightdropprofile} ref={dropdownRef}>
                    {allSessionData?.map((item: any, index: number) => {
                      const unreadCountObj = unReadMessgCount?.find((item1: any) => item1?.sessionId == item?.sessionId);
                      const unreadCount = unreadCountObj?.unReadCount || 0;
                      const initials = item?.calledPersonDetails?.firstName?.trim() ? (item?.calledPersonDetails?.firstName?.charAt(0).toUpperCase() + item?.calledPersonDetails?.lastName?.charAt(0).toUpperCase()) : 'N';
                      return (
                        <div key={index} className={`${styles.centerscrollivr} ${currentTab(item) ? styles.activetab : ""}`}
                          onClick={() => { item?.isInteractionView ? interactionOnClick(item) : switchChatSession(item) }}
                        >
                          <div className={styles.centerscrollivrqueue}>
                            {(!item.hasOwnProperty("type") && !item?.isInteractionView) ? <div className={styles.isintviewimgwrapper}><span className={
                              item.channelType === "Email" ? "icon__ChatEmail24"
                                : item.channelType === "Sms" ? "icon__sms24"
                                  : item.channelType === "Whatsapp" ? "icon__Chatwhatsapp24" : item.channelType === "Facebook" ? "icon__InteractionFacebook24"
                                    : item.channelType === "Instagram" ? "icon__InteractionInsta24"
                                      : item.channelType === "Voicemail" ? "icon__Voicemail36"
                                        : (item.CallHistoryId || (item?.result && item?.result[0]?.CallHistoryId && parseInt(item?.result[0]?.CallHistoryId))) ? "icon__InteractionInCallTrans24"
                                          : (item?.ChatHistoryId || item?.channelType === 'Chat') ? "icon__InteractionMessage24 smsmic"
                                            : ""}></span></div>
                              : <div className={styles.chatusername}>{initials}</div>
                            }
                            <div className={styles.ivrqueue}>
                              <h5 className='cname cnametrim'>{item?.calledPersonDetails?.firstName?.trim() ?
                                (item?.calledPersonDetails?.lastName ? (item?.calledPersonDetails?.firstName + " " + item?.calledPersonDetails?.lastName)
                                  : item?.calledPersonDetails?.firstName)
                                : 'New customer'}</h5>
                              {item?.isInteractionView ?
                                <span className={
                                  item?.dispositionName === "Closed"
                                    ? `${styles.statusText} ${styles.closed}`
                                    : item?.dispositionName === "Unresolved"
                                      ? `${styles.statusText} ${styles.unresolved}`
                                      : item?.dispositionName === "Resolved"
                                        ? `${styles.statusText} ${styles.resolved}`
                                        : item?.dispositionName === "Follow-up"
                                          ? `${styles.statusText} ${styles.followUp}`
                                          : item?.dispositionName === "Do not contact"
                                            ? `${styles.statusText} ${styles.disconnected}`
                                            : item?.dispositionName === "Transferred"
                                              ? `${styles.statusText} ${styles.transferred}`
                                              : // : !val?.dispositionName
                                              `${styles.statusText} ${styles.notFound}`
                                }
                                >{item?.dispositionName}</span>
                                :

                                (!item?.sessionEndTime
                                  && (item.channelType !== "Voicemail"
                                    && !['view', 'whisper', 'barge'].includes(item?.supervisorStatus)
                                    && currentSession?.callBack !== 1 || (item.CallBackStatus != 1 && item.CallBackStatus !== null)
                                    && ['Email', 'Sms', 'Whatsapp', 'Facebook', 'Instagram'].includes(item.channelType)
                                  )
                                ) &&
                                <p>{`Ongoing ${item.CallHistoryId || item.channelType === "Call" ? "Call" : item?.ChatHistoryId || item?.channelType === 'Chat'
                                  ? "Chat"
                                  : ['Email', 'Sms', 'Whatsapp', 'Facebook', 'Instagram'].includes(item.channelType)
                                    ? item.channelType
                                    : ''}`}</p>
                              }
                            </div>
                          </div>
                          {(unreadCount > 0 && !item?.isInteractionView) ? <span className={`countest drcountest ${unreadCount === 0 ? styles.counthid : ''}`}>{unreadCount}</span> : ''}
                          {unreadCount === 0 &&
                            (!item?.isInteractionView && !item?.sessionEndTime
                              && (item.channelType !== "Voicemail"
                                && !['view', 'whisper', 'barge'].includes(item?.supervisorStatus)
                                && currentSession?.callBack !== 1 || (item.CallBackStatus != 1 && item.CallBackStatus !== null)
                                && ['Email', 'Sms', 'Whatsapp', 'Facebook', 'Instagram'].includes(item.channelType)
                              )
                            )

                            ? <span className={`${styles.timerColor} ${unreadCount !== 0 ? styles.tabhid : ''} `}>
                              {(item?.ChatHistoryId || item?.channelType === 'Chat')
                                ? <Timer sessiondata={item} />
                                : ['Email', 'Sms', 'Whatsapp', 'Facebook', 'Instagram'].includes(item.channelType)
                                  ? <Timer sessiondata={item} />
                                  : (item.CallHistoryId || item.channelType === "Call")
                                    ? (<span>{item?.callDuration && item?.callDuration.toString().includes(":")
                                      ? item?.callDuration
                                      : (!formatElapsedTime(item?.callDuration).includes("00:00:00")
                                        ? formatElapsedTime(item?.callDuration)
                                        : getTransferTime())}</span>)
                                    :
                                    (!['Email', 'Sms', 'Whatsapp', 'Facebook', 'Instagram'].includes(item.channelType))
                                      ? <span>
                                        {item.callType === "outbound" && incomingCallDetail.callStatus !== "accepted"
                                          ? incomingCallDetail.callStatus
                                          : item.callType === "outbound" && incomingCallDetail.callStatus === "accepted"
                                            ? incomingCallDetail.callduration :
                                            item?.callDuration
                                              ? item?.callDuration
                                              : currentCallDuration}
                                      </span> : ''
                              }</span>
                            : (!item?.sessionEndTime
                              && (item.channelType !== "Voicemail"
                                && !['view', 'whisper', 'barge'].includes(item?.supervisorStatus)
                                && currentSession?.callBack !== 1 || (item.CallBackStatus != 1 && item.CallBackStatus !== null)
                                && ['Email', 'Sms', 'Whatsapp', 'Facebook', 'Instagram'].includes(item.channelType)
                              ) && !item?.isInteractionView
                            ) ? '' :
                              <span style={{ width: '34px', textAlign: 'center' }} onClick={() => CloseSession(item?.sessionId)}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="10"
                                  height="11"
                                  viewBox="0 0 10 11"
                                  fill="none"
                                >
                                  <path
                                    d="M5.80082 5.50035L9.70415 1.59668C9.92548 1.37595 9.92548 1.01662 9.70415 0.795883C9.48282 0.574549 9.12342 0.574549 8.90335 0.795883L5.00002 4.69948L1.09668 0.795883C0.876616 0.574549 0.515949 0.574549 0.295883 0.795883C0.0745495 1.01662 0.0745495 1.37595 0.295883 1.59668L4.19922 5.50035L0.295883 9.40402C0.0745495 9.62475 0.0745495 9.98408 0.295883 10.2048C0.406549 10.3155 0.551083 10.3708 0.696283 10.3708C0.841483 10.3708 0.986616 10.3155 1.09668 10.2048L5.00002 6.30122L8.90335 10.2048C9.01335 10.3155 9.15855 10.3708 9.30375 10.3708C9.44895 10.3708 9.59348 10.3155 9.70415 10.2048C9.92548 9.98408 9.92548 9.62475 9.70415 9.40402L5.80082 5.50035Z"
                                    fill="#757676"
                                  />
                                </svg>
                              </span>
                          }
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
            <div className={`${styles.right1} ${styles.rightmaintop}`} >
              <div className={`${styles.drppers} `}>
                {(userRoleId === ROLES.AGENT_ROLE_ID || userRoleId === ROLES.SUPERVISOR_ROLE_ID || userRoleId === ROLES.ADMIN_ROLE_ID) && <div className={currentSession?.channelType === 'Call' ? `${styles.drpDwn} sixth-step fourth-step3 ninth-step ` : `${styles.drpDwn} sixth-step fourth-step3 ninth-step`} onClick={handleDropdown}>
                  {currentStatus?.statusName?.toLowerCase() === "ready" ||
                    currentStatus?.statusName?.toLowerCase() === "not ready" ||
                    currentStatus?.statusName?.toLowerCase() === "transfer only" ||
                    currentStatus?.statusName?.toLowerCase() === "away" ||
                    currentStatus?.statusName?.toLowerCase() === "busy" ||
                    currentStatus?.statusName?.toLowerCase() === "offline" ? (
                    <span
                      className={
                        currentStatus?.statusName?.toLowerCase() === "ready"
                          ? `${styles.ready} ${styles.whiteDot}`
                          : currentStatus?.statusName?.toLowerCase() === "not ready"
                            ? `${styles.notReady} ${styles.whiteDot}`
                            : currentStatus?.statusName?.toLowerCase() === "transfer only"
                              ? `${styles.transferOnly} ${styles.whiteDot}`
                              : currentStatus?.statusName?.toLowerCase() === "busy"
                                ? `${styles.busy} ${styles.whiteDot}`
                                : currentStatus?.statusName?.toLowerCase() === "away"
                                  ? `${styles.break} ${styles.whiteDot}`
                                  : `${styles.offline} ${styles.whiteDot}`
                      }
                    ></span>
                  ) : (
                    <span style={{ backgroundColor: currentStatus?.colorCode ?? "red" }} className={styles.whiteDot}></span>
                  )}

                  <span className={styles.readyTxt}>{currentStatus?.statusName || 'Not Ready'}</span>
                  <Dropdown
                    overlay={menu}
                    trigger={["hover"]}
                    placement="bottomRight"
                    getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
                    overlayClassName="readyMenu"
                    visible={showDropdown}
                    onVisibleChange={setShowDropdown}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none" onClick={(e) => e.stopPropagation()}>
                      <path d="M6.00155 5.90231C5.39905 5.90231 4.83355 5.66791 4.40825 5.24121L0.554751 1.37691C0.262251 1.08391 0.263251 0.609307 0.556251 0.316407C0.850151 0.024407 1.32525 0.0244068 1.61725 0.318407L5.47025 4.18271C5.75395 4.46591 6.24955 4.46591 6.53225 4.18271L10.3858 0.318407C10.6778 0.0245068 11.1529 0.024507 11.4468 0.316407C11.7398 0.609407 11.7407 1.08401 11.4483 1.37691L7.59475 5.24121C7.16945 5.66801 6.60365 5.90231 6.00155 5.90231Z" fill="#757676" />
                    </svg>
                  </Dropdown>
                </div>}
              </div>
              <div className={styles.drppersicon}>
                <>
                  {
                    productid === "1" && hassAccess('dialPad/Hide') &&
                    <Tooltip title="Call" placement="bottom" >
                      <span className={`${styles.callIcon} seventh-step_call fifth-step3`} onClick={openDialPad}>
                        {
                          // Object.keys(popUpDetails?.incomingCallDetail)?.length == 0
                          !popUpDetails?.incomingCallDetail?.guid
                            ?
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                              <path d="M2.28431 1.00302L2.49351 0.861416C3.66101 0.112416 5.20631 0.375615 6.10371 1.47572L7.33201 2.98722C8.09451 3.92522 8.20241 5.24792 7.58831 6.28042L6.58281 7.98772C6.42091 8.25752 6.89991 9.11472 8.09441 10.3224C9.30231 11.517 10.1595 11.996 10.4361 11.841L12.1367 10.8285C13.1759 10.2213 14.4918 10.3224 15.4365 11.0917L16.9481 12.32C18.0481 13.2175 18.3113 14.7629 17.5555 15.9235L17.4205 16.1396C16.3949 17.7321 14.4851 18.6835 12.5619 18.3396C10.0717 17.8872 7.49391 16.3084 4.79471 13.6226C2.11561 10.93 0.52981 8.34552 0.0844096 5.86212C-0.25969 3.93882 0.69171 2.02892 2.28431 1.00302Z" fill="#000" />
                            </svg>
                            :
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                              <path d="M2.28422 0.580042L2.49342 0.438442C3.66092 -0.310558 5.20622 -0.0473582 6.10362 1.05274L7.33192 2.56424C8.09442 3.50224 8.20232 4.82494 7.58822 5.85744L6.58272 7.56474C6.42082 7.83454 6.89982 8.69174 8.09432 9.89944C9.30222 11.094 10.1594 11.573 10.436 11.418L12.1366 10.4055C13.1758 9.79834 14.4917 9.89944 15.4364 10.6687L16.948 11.897C18.048 12.7945 18.3112 14.3399 17.5554 15.5005L17.4204 15.7166C16.3948 17.3091 14.485 18.2605 12.5618 17.9166C10.0716 17.4642 7.49382 15.8854 4.79462 13.1996C2.11552 10.507 0.529718 7.92254 0.0843181 5.43914C-0.259782 3.51584 0.691618 1.60594 2.28422 0.580042Z" fill="#000" />
                            </svg>}
                      </span>
                    </Tooltip>
                  }
                  <OncallPad resetTrigger={resetTrigger} />
                </>

                {loginPlanDetail != 54 && <Tooltip title="Tracker" placement="bottom">
                  <div className="trackericon eighth-step sixth-step3 trackericonnew">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" onClick={showDrawer}>
                      <path d="M10.2085 3.95051C11.2983 3.95051 12.1818 3.06703 12.1818 1.97721C12.1818 0.887383 11.2983 0.00390625 10.2085 0.00390625C9.11868 0.00390625 8.2352 0.887383 8.2352 1.97721C8.2352 3.06703 9.11868 3.95051 10.2085 3.95051Z" fill="#000" />
                      <path d="M4.4794 6.15851C5.56922 6.15851 6.4527 5.27503 6.4527 4.18521C6.4527 3.09538 5.56922 2.21191 4.4794 2.21191C3.38958 2.21191 2.5061 3.09538 2.5061 4.18521C2.5061 5.27503 3.38958 6.15851 4.4794 6.15851Z" fill="#000" />
                      <path d="M1.9874 11.7141C3.08501 11.7141 3.9748 10.8243 3.9748 9.72671C3.9748 8.6291 3.08501 7.73931 1.9874 7.73931C0.889789 7.73931 0 8.6291 0 9.72671C0 10.8243 0.889789 11.7141 1.9874 11.7141Z" fill="#000" />
                      <path d="M4.1962 17.5038C5.28602 17.5038 6.1695 16.6203 6.1695 15.5305C6.1695 14.4407 5.28602 13.5572 4.1962 13.5572C3.10638 13.5572 2.2229 14.4407 2.2229 15.5305C2.2229 16.6203 3.10638 17.5038 4.1962 17.5038Z" fill="#000" />
                      <path d="M9.808 19.9952C10.8978 19.9952 11.7813 19.1117 11.7813 18.0219C11.7813 16.9321 10.8978 16.0486 9.808 16.0486C8.71818 16.0486 7.8347 16.9321 7.8347 18.0219C7.8347 19.1117 8.71818 19.9952 9.808 19.9952Z" fill="#000" />
                      <path d="M15.537 17.7871C16.6268 17.7871 17.5103 16.9036 17.5103 15.8138C17.5103 14.724 16.6268 13.8405 15.537 13.8405C14.4472 13.8405 13.5637 14.724 13.5637 15.8138C13.5637 16.9036 14.4472 17.7871 15.537 17.7871Z" fill="#000" />
                      <path d="M18.0274 12.1732C19.1172 12.1732 20.0007 11.2897 20.0007 10.1999C20.0007 9.11008 19.1172 8.22661 18.0274 8.22661C16.9376 8.22661 16.0541 9.11008 16.0541 10.1999C16.0541 11.2897 16.9376 12.1732 18.0274 12.1732Z" fill="#000" />
                      <path d="M10.0083 14.5792C12.5376 14.5792 14.588 12.5288 14.588 9.99951C14.588 7.47021 12.5376 5.41981 10.0083 5.41981C7.479 5.41981 5.4286 7.47021 5.4286 9.99951C5.4286 12.5288 7.479 14.5792 10.0083 14.5792Z" fill="#000" />
                      <path d="M15.8202 6.44181C16.91 6.44181 17.7935 5.55833 17.7935 4.46851C17.7935 3.37868 16.91 2.49521 15.8202 2.49521C14.7304 2.49521 13.8469 3.37868 13.8469 4.46851C13.8469 5.55833 14.7304 6.44181 15.8202 6.44181Z" fill="#000" />
                    </svg>
                    {/* {queueTrackerData?.reduce((acc: any, curr: any) => acc + (isJSON(curr?.queueList) ? JSON.parse(curr?.queueList ?? '[]')?.length : curr?.queueList?.length), 0) > 0 && ( */}
                    {queueCount > 0 && queueTrackerData?.reduce((acc: any, curr: any) => isJSON(curr?.queueList) ? acc + JSON.parse(curr?.queueList ?? '[]')?.length : acc + curr?.queueList?.length, 0) > 0 && (
                      <span className="trackerbadgeCount">{queueCount}</span>
                    )}
                  </div>
                </Tooltip>}
                <span className='lineborderinheader'></span>
                <Tooltip title="Notification" placement="bottom" >
                  <div className={`notificationalert  notificationalertnew ${unReadCount?.unReadCount && "notificationwithoutbadge"}`}>
                    <Popover
                      overlayClassName="notificationalert  notificationalerpopover "
                      trigger="click"
                      content={content1}
                      placement="bottomRight"
                      className="notificationwithoutbadge tenth-step-s ninth-step-s seventh-step3"
                      // title={
                      //   <h6 className={styles.notificationheader}>
                      //    <span>Notification </span> <span onClick={clearAll}>Close</span>
                      //   </h6>
                      // }
                      open={shortcutKeysSlice.isBellModalOpen}
                      onOpenChange={(visible) => dispatch(shortcutKeyActions.setIsBellModalOpen(visible))}
                      onVisibleChange={(visible) => {
                      }}
                    >
                       {<Popover /> ?
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
                          <path d="M10.934 17.2429H7.06695C6.60995 17.2429 6.32315 17.8213 6.54495 18.2888C7.02395 19.2973 7.94415 19.9797 9.00035 19.9797C10.0565 19.9797 10.9769 19.2973 11.4557 18.2888C11.6776 17.8213 11.3911 17.2429 10.934 17.2429Z" fill="#000" />
                          <path d="M16.7598 13.7182C16.2043 13.2241 15.7369 12.6645 15.3988 12.0004C14.9814 11.1806 14.7866 10.3105 14.7903 9.39048C14.7935 8.51968 14.8173 7.64658 14.7639 6.77868C14.6216 4.47058 12.6321 2.17978 10.4986 1.58968C10.4758 1.58338 10.4589 1.58038 10.437 1.57478C10.4397 1.53918 10.4477 1.50518 10.4477 1.46878C10.4477 0.669484 9.79965 0.0214844 9.00045 0.0214844C8.20125 0.0214844 7.55315 0.669384 7.55315 1.46878C7.55315 1.50518 7.56125 1.53908 7.56375 1.57478C7.54175 1.58038 7.52485 1.58328 7.50195 1.58968C5.36875 2.17978 3.37905 4.47058 3.23695 6.77868C3.18345 7.64658 3.20715 8.51968 3.21055 9.39048C3.21405 10.3104 3.01915 11.1805 2.60195 12.0004C2.26395 12.6645 1.79645 13.224 1.24115 13.7182C0.798647 14.1115 0.638647 14.61 0.789947 15.1872C0.968147 15.8662 1.53265 16.2604 2.30285 16.2604C4.53525 16.2606 6.76765 16.2606 9.00035 16.2604C11.2327 16.2606 13.4654 16.2606 15.6978 16.2604C16.4681 16.2604 17.0325 15.8661 17.2106 15.1872C17.3618 14.6101 17.2021 14.1115 16.7598 13.7182Z" fill="#000" />
                        </svg> :
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
                          <path d="M10.934 17.2429H7.06695C6.60995 17.2429 6.32315 17.8213 6.54495 18.2888C7.02395 19.2973 7.94415 19.9797 9.00035 19.9797C10.0565 19.9797 10.9769 19.2973 11.4557 18.2888C11.6776 17.8213 11.3911 17.2429 10.934 17.2429Z" fill="#000" />
                          <path d="M16.7598 13.7182C16.2043 13.2241 15.7369 12.6645 15.3988 12.0004C14.9814 11.1806 14.7866 10.3105 14.7903 9.39048C14.7935 8.51968 14.8173 7.64658 14.7639 6.77868C14.6216 4.47058 12.6321 2.17978 10.4986 1.58968C10.4758 1.58338 10.4589 1.58038 10.437 1.57478C10.4397 1.53918 10.4477 1.50518 10.4477 1.46878C10.4477 0.669484 9.79965 0.0214844 9.00045 0.0214844C8.20125 0.0214844 7.55315 0.669384 7.55315 1.46878C7.55315 1.50518 7.56125 1.53908 7.56375 1.57478C7.54175 1.58038 7.52485 1.58328 7.50195 1.58968C5.36875 2.17978 3.37905 4.47058 3.23695 6.77868C3.18345 7.64658 3.20715 8.51968 3.21055 9.39048C3.21405 10.3104 3.01915 11.1805 2.60195 12.0004C2.26395 12.6645 1.79645 13.224 1.24115 13.7182C0.798647 14.1115 0.638647 14.61 0.789947 15.1872C0.968147 15.8662 1.53265 16.2604 2.30285 16.2604C4.53525 16.2606 6.76765 16.2606 9.00035 16.2604C11.2327 16.2606 13.4654 16.2606 15.6978 16.2604C16.4681 16.2604 17.0325 15.8661 17.2106 15.1872C17.3618 14.6101 17.2021 14.1115 16.7598 13.7182Z" fill="#000" />
                        </svg>}
                      {unReadCount?.unReadCount !== 0 && unReadCount?.unReadCount > 0 && (
                        <span className={styles.notificationcount}>
                          {unReadCount?.unReadCount}
                        </span>
                      )}
                    </Popover>
                  </div>
                </Tooltip>

                {hassAccess('aiChat') && <>
                  <span className='lineborderinheader'></span>
                  <Tooltip title="AI Chat" placement="bottom" >
                    <div className={styles.dynamicdashboard}>
                      {/* <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" onClick={() => dispatch(DynamicDashboardSliceActions.setDynamicDashboardStatus(true))}>
                        <path d="M17.5447 2.46743L16.2564 1.19513C15.964 0.906426 15.5832 0.762226 15.2024 0.762226C14.8154 0.762326 14.4285 0.911126 14.1351 1.20823L1.53852 13.962C0.956322 14.5514 0.962222 15.5011 1.55162 16.0832L2.83992 17.3557C3.13232 17.6444 3.51312 17.7886 3.89392 17.7886C4.28092 17.7886 4.66782 17.6397 4.96122 17.3426L17.5578 4.58883C18.14 3.99943 18.1341 3.04953 17.5447 2.46743ZM13.7886 6.27043L12.4975 5.00003L15.201 2.26253L15.2025 2.26243L16.4908 3.53473L13.7886 6.27043Z" fill="#757676" />
                        <path d="M15.9083 12.5027L15.1338 10.5663C15.0687 10.4696 14.9885 10.4213 14.8916 10.4213C14.7949 10.4213 14.714 10.4696 14.6497 10.5663L13.8752 12.5027L11.9388 13.2774C11.8421 13.3422 11.7935 13.4224 11.7935 13.5195C11.7935 13.6162 11.842 13.6972 11.9388 13.7614L13.8752 14.5358L14.6497 16.4722C14.7141 16.569 14.7949 16.6175 14.8916 16.6175C14.9886 16.6175 15.0687 16.569 15.1338 16.4722L15.9083 14.5358L17.8447 13.7614C17.9414 13.6972 17.9899 13.6161 17.9899 13.5195C17.9899 13.4225 17.9414 13.3423 17.8447 13.2774L15.9083 12.5027Z" fill="#757676" />
                        <path d="M2.86562 7.86613C2.93012 7.96283 3.01092 8.01143 3.10762 8.01143C3.20462 8.01143 3.28472 7.96283 3.34982 7.86613L4.12432 5.92973L6.06072 5.15523C6.15742 5.09103 6.20602 5.00993 6.20602 4.91333C6.20602 4.81643 6.15752 4.73623 6.06072 4.67143L4.12432 3.89673L3.34982 1.96023C3.28472 1.86353 3.20462 1.81523 3.10762 1.81523C3.01092 1.81523 2.93002 1.86353 2.86562 1.96023L2.09112 3.89673L0.154822 4.67143C0.0580216 4.73623 0.00952148 4.81643 0.00952148 4.91333C0.00952148 5.01003 0.0580216 5.09103 0.154822 5.15523L2.09112 5.92973L2.86562 7.86613Z" fill="#757676" />
                        <path d="M8.22772 2.92453L8.73842 4.20143C8.78092 4.26523 8.83422 4.29723 8.89792 4.29723C8.96192 4.29723 9.01472 4.26523 9.05762 4.20143L9.56832 2.92453L10.8452 2.41403C10.909 2.37153 10.941 2.31813 10.941 2.25433C10.941 2.19033 10.909 2.13763 10.8452 2.09483L9.56832 1.58393L9.05762 0.307026C9.01472 0.243326 8.96182 0.211426 8.89792 0.211426C8.83412 0.211426 8.78082 0.243326 8.73842 0.307026L8.22772 1.58393L6.95082 2.09483C6.88702 2.13763 6.85502 2.19043 6.85502 2.25433C6.85502 2.31803 6.88702 2.37153 6.95082 2.41403L8.22772 2.92453Z" fill="#757676" />
                      </svg> */}
                      <img src={Aigenerate} alt="" onClick={() => dispatch(DynamicDashboardSliceActions.setDynamicDashboardStatus(true))}/>
                    </div>
                  </Tooltip>
                </>}

                {dynamicDashboard?.dynamicDashboardStatus && <Dynamicdash />}

                <span className='lineborderinheader'></span>
                <Tooltip title="Apps" placement="bottom" >

                  <div className="worktualpro">
                  <div className={isVisible ? "worktualprotop iconacts" : "worktualprotop"} ref={appIcon}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <g clip-path="url(#clip0_2145_12698)">
                          <path d="M2.20938 4.36894C3.42193 4.36894 4.40489 3.39094 4.40489 2.18452C4.40489 0.978093 3.42193 9.06591e-05 2.20938 9.06591e-05C0.99683 9.06591e-05 0.0138638 0.978093 0.0138638 2.18452C0.0138638 3.39094 0.99683 4.36894 2.20938 4.36894Z" fill="#000" />
                          <path d="M8.04406 4.36894C9.25661 4.36894 10.2396 3.39094 10.2396 2.18452C10.2396 0.978093 9.25661 9.06591e-05 8.04406 9.06591e-05C6.83151 9.06591e-05 5.84855 0.978093 5.84855 2.18452C5.84855 3.39094 6.83151 4.36894 8.04406 4.36894Z" fill="#000" />
                          <path d="M13.8045 4.36885C15.017 4.36885 16 3.39085 16 2.18443C16 0.978001 15.017 0 13.8045 0C12.5919 0 11.609 0.978001 11.609 2.18443C11.609 3.39085 12.5919 4.36885 13.8045 4.36885Z" fill="#000" />
                          <path d="M2.20938 10.1585C3.42193 10.1585 4.40489 9.18049 4.40489 7.97406C4.40489 6.76764 3.42193 5.78964 2.20938 5.78964C0.99683 5.78964 0.0138638 6.76764 0.0138638 7.97406C0.0138638 9.18049 0.99683 10.1585 2.20938 10.1585Z" fill="#000" />
                          <path d="M8.04406 10.1585C9.25661 10.1585 10.2396 9.18049 10.2396 7.97406C10.2396 6.76764 9.25661 5.78964 8.04406 5.78964C6.83151 5.78964 5.84855 6.76764 5.84855 7.97406C5.84855 9.18049 6.83151 10.1585 8.04406 10.1585Z" fill="#000" />
                          <path d="M13.8045 10.1584C15.017 10.1584 16 9.1804 16 7.97397C16 6.76755 15.017 5.78955 13.8045 5.78955C12.5919 5.78955 11.609 6.76755 11.609 7.97397C11.609 9.1804 12.5919 10.1584 13.8045 10.1584Z" fill="#000" />
                          <path d="M8.03012 16C9.24267 16 10.2256 15.022 10.2256 13.8156C10.2256 12.6091 9.24267 11.6311 8.03012 11.6311C6.81757 11.6311 5.83461 12.6091 5.83461 13.8156C5.83461 15.022 6.81757 16 8.03012 16Z" fill="#000" />
                          <path d="M2.19578 16C3.40832 16 4.39129 15.022 4.39129 13.8156C4.39129 12.6091 3.40832 11.6311 2.19578 11.6311C0.983227 11.6311 0.000261123 12.6091 0.000261123 13.8156C0.000261123 15.022 0.983227 16 2.19578 16Z" fill="#000" />
                          <path d="M13.7906 16C15.0032 16 15.9861 15.022 15.9861 13.8156C15.9861 12.6091 15.0032 11.6311 13.7906 11.6311C12.5781 11.6311 11.5951 12.6091 11.5951 13.8156C11.5951 15.022 12.5781 16 13.7906 16Z" fill="#000" />
                        </g>
                        <defs>
                          <clipPath id="clip0_2145_12698">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    {isVisible &&
                      <div className="worktualprobottom" ref={divRef}>
                        <ul className="worktualproul">

                          {productid == 15 ?
                            <li className="worktualactive" >


                              <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_672_6284)">
                                  <path d="M21.9617 7.93762V11.7639C22.5967 11.7102 23.0952 11.2385 23.0952 10.6576V9.04397C23.0952 8.46309 22.5967 7.99141 21.9617 7.93762Z" fill="#000" />
                                  <path d="M7.96044 7.93762V11.7639C7.32542 11.7102 6.8269 11.2385 6.8269 10.6576V9.04397C6.8269 8.46309 7.32542 7.99141 7.96044 7.93762Z" fill="#000" />
                                  <path d="M15.821 4.21097C15.8096 3.73532 15.4199 3.35767 14.946 3.35767H14.9243C14.4412 3.36968 14.0596 3.77125 14.071 4.25437L14.0995 5.4159C14.1109 5.89155 14.5006 6.2692 14.9745 6.2692H14.9962C15.4793 6.25718 15.8609 5.85562 15.8495 5.3725L15.821 4.21097Z" fill="#000" />
                                  <path d="M21.2957 16.1793H16.9127V16.1752H13.0049V16.1793H8.62193C7.44558 16.1793 6.49194 17.1329 6.49194 18.3092V19.4343H6.49883C6.54293 20.4494 6.82129 21.7227 7.96148 22.7631C9.16886 23.8647 11.2262 24.5965 14.6334 24.6402V24.6423H15.2845V24.6402C18.6917 24.5965 20.749 23.8647 21.9565 22.7631C23.0966 21.7227 23.3749 20.4494 23.4191 19.4343H23.426V18.3092C23.426 17.1329 22.472 16.1793 21.2957 16.1793Z" fill="#000" />
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M21.4307 8.79962L21.433 8.89248C21.4409 9.216 21.4409 9.53508 21.4409 9.853C21.4472 10.12 21.4418 10.4072 21.4364 10.693C21.436 10.7146 21.4356 10.7361 21.4352 10.7576L21.4307 10.9074C21.4079 11.726 21.3726 12.9633 20.1763 13.7449C19.1179 14.4382 17.6959 14.5179 16.4472 14.5385C15.8958 14.5481 15.4252 14.5533 14.9547 14.5533C14.4832 14.5533 14.0137 14.5481 13.46 14.5385C12.2125 14.5179 10.7917 14.4381 9.73215 13.7449C8.53585 12.9628 8.5005 11.7242 8.47775 10.9051L8.47437 8.9136C8.5005 7.98785 8.53585 6.7506 9.73098 5.96275C10.7917 5.26823 12.2125 5.18855 13.4612 5.16802C14.5651 5.14923 15.3422 5.14923 16.4484 5.16802C17.6959 5.18855 19.1179 5.26835 20.1774 5.96158C21.3726 6.74372 21.4079 7.98097 21.4307 8.79962ZM11.4457 9.85073C11.4457 10.5245 11.9917 11.0706 12.6655 11.0706C13.3391 11.0706 13.8854 10.5244 13.8854 9.85073C13.8854 9.17709 13.3392 8.63086 12.6655 8.63086C11.9917 8.63086 11.4457 9.17698 11.4457 9.85073ZM16.0315 9.85073C16.0315 10.5245 16.5775 11.0706 17.2513 11.0706C17.9249 11.0706 18.4713 10.5244 18.4713 9.85073C18.4713 9.17709 17.925 8.63086 17.2513 8.63086C16.5775 8.63086 16.0315 9.17698 16.0315 9.85073Z" fill="black" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_672_6284">
                                    <rect width="28" height="28" fill="white" transform="translate(0.958984)" />
                                  </clipPath>
                                </defs>
                              </svg>
                              Chatbox
                            </li>
                            :
                            <li className="worktualactive">

                              <svg width="65" height="64" viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "29px" }}>
                                <g clip-path="url(#clip0_4226_241511)">
                                  <path d="M33.6962 25.0007H31.2962V38.9999H33.6962V25.0007Z" fill="black" />
                                  <path d="M37.7882 28.3801H35.3882V35.8403H37.7882V28.3801Z" fill="black" />
                                  <path d="M29.6039 28.3801H27.2039V35.8403H29.6039V28.3801Z" fill="black" />
                                  <path d="M25.5117 30.4824H23.1117V33.7402H25.5117V30.4824Z" fill="black" />
                                  <path d="M41.8758 30.4824H39.4758V33.7402H41.8758V30.4824Z" fill="black" />
                                  <path d="M32.4971 46.4623H18.0378V35.6003H8.79878C10.54 47.1427 20.4719 56.0003 32.5 56.0003C44.5281 56.0003 54.46 47.1427 56.2012 35.6003H46.4915C44.8878 41.8425 39.2389 46.4623 32.4971 46.4623Z" fill="#000" />
                                  <path d="M32.5065 17.5381C39.2471 17.5381 44.8936 22.1583 46.4934 28.4H56.2012C54.46 16.8577 44.5281 8 32.5 8C20.4719 8 10.54 16.8577 8.79878 28.4H18.5094C20.1141 22.1576 25.7629 17.5381 32.5065 17.5381Z" fill="#000" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_4226_241511">
                                    <rect width="64" height="64" fill="white" transform="translate(0.5)" />
                                  </clipPath>
                                </defs>
                              </svg>{countryCode === 'com' ? "AI Contact Center" : "AI Contact Centre"}
                            </li>
                          }
                          {(productid !== '1' && LoginUserDetails?.domainId !== 19489 && (ROLES.ADMIN_ROLE_ID == LoginCcaasUserDetails?.roleid || ROLES.SUPERVISOR_ROLE_ID == LoginCcaasUserDetails?.roleid) || LoginUserDetails?.domainId === 18878) ? //18878 domainId of Cinimini
                            <>
                              {(emailApointmentAddOn?.booking || LoginUserDetails?.domainId === 18878) &&
                                <li onClick={() => {
                                  if (process.env.REACT_APP_ENV === 'production') {
                                    switch (countryCode) {
                                      case 'uk': {
                                        window.location.href = "https://booking.worktual.co.uk/";
                                        break;
                                      }
                                      case 'in': {
                                        window.location.href = "https://booking.worktual.in/";
                                        break;
                                      }
                                      case 'com': {
                                        window.location.href = "https://booking.worktual.com/";
                                        break;
                                      }
                                    }
                                  } else if (process.env.REACT_APP_ENV === 'qa') {
                                    switch (countryCode) {
                                      case 'uk': {
                                        window.location.href = "https://stagebooking.worktual.co.uk/";
                                        break;
                                      }
                                      case 'in': {
                                        window.location.href = "https://stagebooking.worktual.in/";
                                        break;
                                      }
                                      case 'com': {
                                        window.location.href = "https://stagebooking.worktual.com/";
                                        break;
                                      }
                                    }
                                  } else {
                                    switch (countryCode) {
                                      case 'uk': {
                                        window.location.href = "https://stagebooking.worktual.co.uk/";
                                        break;
                                      }
                                      case 'in': {
                                        window.location.href = "https://stagebooking.worktual.in/";
                                        break;
                                      }
                                      case 'com': {
                                        window.location.href = "https://stagebooking.worktual.com/";
                                        break;
                                      }
                                    }
                                  }
                                }}>
                                  <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.1513 8.34147C17.6964 8.34147 17.3274 7.97247 17.3274 7.51757V4.3239C17.3274 3.869 17.6964 3.5 18.1513 3.5C18.6062 3.5 18.9752 3.869 18.9752 4.3239V7.51757C18.9752 7.97247 18.6062 8.34147 18.1513 8.34147Z" fill="#e6e4eb" />
                                    <path d="M11.766 8.34147C11.3111 8.34147 10.9421 7.97247 10.9421 7.51757V4.3239C10.9421 3.869 11.3111 3.5 11.766 3.5C12.2209 3.5 12.5899 3.869 12.5899 4.3239V7.51757C12.5899 7.97247 12.2209 8.34147 11.766 8.34147Z" fill="#e6e4eb" />
                                    <path d="M22.9462 6.90953C21.5554 5.49077 19.5107 5.28216 17.6052 5.24041C16.7289 5.21954 15.8491 5.20911 14.9694 5.20911C14.0897 5.20911 13.2098 5.21954 12.3335 5.24041C10.428 5.29611 8.38341 5.49077 6.99233 6.90953C5.99233 7.91909 5.68848 9.37146 5.57983 10.799H24.3521C24.2456 9.37212 23.9391 7.92161 22.9462 6.90953Z" fill="black" />
                                    <path d="M24.4207 12.6959C24.4195 12.6153 24.4178 12.5292 24.4165 12.447H5.50992C5.50805 12.534 5.50607 12.6247 5.5042 12.7098C5.4763 14.1424 5.4763 15.5752 5.5042 17.0079C5.532 18.9135 5.532 21.3197 6.97844 22.7941C8.36941 24.213 10.414 24.4215 12.3196 24.4632C13.2571 24.4855 14.1948 24.4999 15.1323 24.4999C15.9476 24.4999 16.7623 24.4891 17.5773 24.4632C19.4829 24.4076 21.5276 24.213 22.9185 22.7941C24.3652 21.3197 24.3511 18.9135 24.393 17.0079C24.393 16.3541 24.4208 15.7142 24.4208 15.0606H24.4347C24.4347 14.2678 24.4346 13.4887 24.4207 12.6959ZM11.4631 20.3137C11.4631 20.4904 11.3197 20.6339 11.1429 20.6339H9.60318C9.4262 20.6339 9.28295 20.4904 9.28295 20.3137V18.7739C9.28295 18.5971 9.4262 18.4537 9.60318 18.4537H11.1429C11.3197 18.4537 11.4631 18.5971 11.4631 18.7739V20.3137ZM11.4631 16.3539C11.4631 16.5307 11.3197 16.6741 11.1429 16.6741H9.60318C9.4262 16.6741 9.28295 16.5307 9.28295 16.3539V14.8141C9.28295 14.6371 9.4262 14.4938 9.60318 14.4938H11.1429C11.3197 14.4938 11.4631 14.6371 11.4631 14.8141V16.3539ZM16.0716 20.3137C16.0716 20.4904 15.9281 20.6339 15.7515 20.6339H14.2116C14.0348 20.6339 13.8914 20.4904 13.8914 20.3137V18.7739C13.8914 18.5971 14.0348 18.4537 14.2116 18.4537H15.7515C15.9281 18.4537 16.0716 18.5971 16.0716 18.7739V20.3137ZM16.4782 15.02L15.3563 16.2909C15.1794 16.4927 14.9232 16.6062 14.6539 16.6046C14.6153 16.6044 14.5757 16.6015 14.5378 16.5964C14.3124 16.5657 14.1058 16.4528 13.9574 16.2767L13.5502 15.7948C13.3696 15.5819 13.3957 15.2623 13.6097 15.0818C13.8228 14.8999 14.1435 14.926 14.3225 15.1412L14.6645 15.5444L15.7186 14.3504C15.9046 14.1387 16.2236 14.1221 16.4332 14.3052C16.6426 14.4908 16.6627 14.8105 16.4782 15.02ZM20.6122 20.3137C20.6122 20.4904 20.4689 20.6339 20.2921 20.6339H18.7522C18.5755 20.6339 18.432 20.4904 18.432 20.3137V18.7739C18.432 18.5971 18.5755 18.4537 18.7522 18.4537H20.2921C20.4689 18.4537 20.6122 18.5971 20.6122 18.7739V20.3137ZM20.6122 16.3539C20.6122 16.5307 20.4689 16.6741 20.2921 16.6741H18.7522C18.5755 16.6741 18.432 16.5307 18.432 16.3539V14.8141C18.432 14.6371 18.5755 14.4938 18.7522 14.4938H20.2921C20.4689 14.4938 20.6122 14.6371 20.6122 14.8141V16.3539Z" fill="#e6e4eb" />
                                  </svg>Appointment Bookings
                                </li>}

                              {(emailApointmentAddOn?.email || LoginUserDetails?.domainId === 18878) &&
                                <li onClick={() => {
                                  if (process.env.REACT_APP_ENV === 'production') {
                                    switch (countryCode) {
                                      case 'uk': {
                                        window.location.href = "https://marketing.worktual.co.uk/";
                                        break;
                                      }
                                      case 'in': {
                                        window.location.href = "https://marketing.worktual.in/";
                                        break;
                                      }
                                      case 'com': {
                                        window.location.href = "https://marketing.worktual.com/";
                                        break;
                                      }
                                    }
                                  } else if (process.env.REACT_APP_ENV === 'qa') {
                                    switch (countryCode) {
                                      case 'uk': {
                                        window.location.href = "https://qamarketing.worktual.co.uk/";
                                        break;
                                      }
                                      case 'in': {
                                        window.location.href = "https://qamarketing.worktual.in/";
                                        break;
                                      }
                                      case 'com': {
                                        window.location.href = "https://qamarketing.worktual.com/";
                                        break;
                                      }
                                    }
                                  } else {
                                    switch (countryCode) {
                                      case 'uk': {
                                        window.location.href = "https://qamarketing.worktual.co.uk/";
                                        break;
                                      }
                                      case 'in': {
                                        window.location.href = "https://qamarketing.worktual.in/";
                                        break;
                                      }
                                      case 'com': {
                                        window.location.href = "https://qamarketing.worktual.com/";
                                        break;
                                      }
                                    }
                                  }
                                }
                                }>
                                  <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_646_90)">
                                      <path d="M25.8872 15.6582C25.5031 14.7798 24.7733 14.155 23.9289 13.8792L25.8615 18.2972C26.235 17.4965 26.2714 16.5366 25.8872 15.6582Z" fill="black" />
                                      <path d="M25.6746 20.2636L22.2153 12.1352C22.0783 11.8609 21.7657 11.5386 21.3375 11.5332C20.9068 11.5274 20.5314 11.825 20.216 12.4175C20.1551 12.5322 20.0908 12.6597 20.022 12.7977C19.6139 13.6147 19.0367 14.7495 17.7513 15.6591L20.0486 21.0604C21.5969 20.7614 22.8142 21.1433 23.6867 21.4154C23.8347 21.4618 23.9718 21.5048 24.0968 21.5401C24.5516 21.6692 24.9222 21.6748 25.204 21.5577C25.3222 21.5085 25.4246 21.4382 25.5111 21.3461C25.8044 21.034 25.789 20.585 25.6746 20.2636Z" fill="black" />
                                      <path d="M15.0132 9.92033L24.047 4.21285C23.4955 3.77336 22.8063 3.5 22.0463 3.5H6.98883C6.20788 3.5 5.50146 3.78839 4.9433 4.24994L14.0234 9.92355C14.3248 10.1116 14.7136 10.1106 15.0132 9.92033Z" fill="#e6e4eb" />
                                      <path d="M13.1845 20.2923C12.9284 19.7193 12.5044 18.77 12.9411 17.6787C13.3324 16.705 14.2293 15.9946 15.9414 15.3015C16.1266 15.2246 16.2617 15.1524 16.3967 15.0826L16.7919 14.8769L17.063 14.6854C18.1229 13.9353 18.6039 12.9698 18.9556 12.2651C19.0301 12.1137 19.1012 11.9751 19.1675 11.8504C19.8314 10.6042 20.7084 10.341 21.3258 10.341C22.1492 10.3503 22.9075 10.8465 23.2836 11.6058L23.6828 12.5433L24.3028 12.746C24.6504 12.8596 24.9716 13.0252 25.2759 13.2168V6.72749C25.2759 6.29253 25.1872 5.87891 25.0311 5.50012L15.8776 11.284C15.4653 11.5457 14.9919 11.676 14.5181 11.676C14.049 11.676 13.5799 11.5477 13.1696 11.2914L3.99056 5.55594C3.84816 5.91994 3.76312 6.31292 3.76312 6.72761V17.4865C3.76312 19.2693 5.20827 20.7142 6.99082 20.7142H13.3708L13.3592 20.6859L13.1845 20.2923Z" fill="#e6e4eb" />
                                      <path d="M18.5682 21.5288C18.7837 21.4323 18.9896 21.3614 19.1949 21.2917L16.9926 16.1142C16.8113 16.2088 16.632 16.3043 16.4276 16.3892C16.4139 16.3949 16.3993 16.4009 16.3849 16.407C15.0126 16.9618 14.2999 17.4859 14.0457 18.122C13.7958 18.7443 14.0466 19.3048 14.2682 19.7996C14.3125 19.899 14.3581 20.0011 14.4121 20.1312L14.4631 20.2447L14.5228 20.3941C14.5693 20.4981 14.6107 20.6017 14.6519 20.7025C14.8545 21.2052 15.085 21.7749 15.7064 22.0267C16.0207 22.1541 16.3905 22.1801 16.8481 22.1022C16.8551 22.1232 16.852 22.1449 16.8605 22.1655L17.5971 23.9389C17.7311 24.2609 18.0283 24.4653 18.3534 24.496C18.4964 24.5095 18.6455 24.4892 18.7875 24.4305C19.2515 24.2378 19.4718 23.7048 19.2791 23.2401L18.5682 21.5288Z" fill="black" />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_646_90">
                                        <rect width="28" height="28" fill="white" transform="translate(0.958984)" />
                                      </clipPath>
                                    </defs>
                                  </svg>Email Marketing
                                </li>}
                            </>
                            : ""
                          }
                          {/* {(![18508,19489].includes(LoginUserDetails?.domainId) && LoginCcaasUserDetails?.roleid !== 7 && LoginCcaasUserDetails?.roleid !== 8) ?
                            <li
                              onClick={() => {
                                if(!hassAccess('Menubar/Ticket')){
                                  dispatch(UserSettingsActions.setUpgradePlan(true))
                                  return
                                }
                                if (process.env.REACT_APP_ENV === 'production') {
                                  switch (countryCode) {
                                    case 'uk': {
                                      window.location.href = "https://tickets.worktual.co.uk/";
                                      break;
                                    }
                                    case 'in': {
                                      window.location.href = "https://tickets.worktual.in/";
                                      break;
                                    }
                                    case 'com': {
                                      window.location.href = "https://tickets.worktual.com/";
                                      break;
                                    }
                                  }
                                } else if (process.env.REACT_APP_ENV === 'qa') {
                                  switch (countryCode) {
                                    case 'uk': {
                                      window.location.href = "https://stage-tickets.worktual.co.uk/";
                                      break;
                                    }
                                    case 'in': {
                                      window.location.href = "https://stage-tickets.worktual.in/";
                                      break;
                                    }
                                    case 'com': {
                                      window.location.href = "https://stage-tickets.worktual.com/";
                                      break;
                                    }
                                  }
                                } else {
                                  switch (countryCode) {
                                    case 'uk': {
                                      window.location.href = "https://stage-tickets.worktual.co.uk/";
                                      break;
                                    }
                                    case 'in': {
                                      window.location.href = "https://stage-tickets.worktual.in/";
                                      break;
                                    }
                                    case 'com': {
                                      window.location.href = "https://stage-tickets.worktual.com/";
                                      break;
                                    }
                                  }
                                }
                              }}>

                               <svg
                                width="24"
                                height="22"
                                viewBox="0 0 24 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">

                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M15.285 4.52359C15.2319 4.34986 15.331 4.16591 15.5047 4.11277C15.6785 4.05963 15.8624 4.15876 15.9155 4.33249L16.2201 5.33296C16.2732
               5.50669 16.1741 5.69065 16.0004 5.74378C15.8266 5.79692 15.6427 5.69779 15.5896 5.52407L15.285 4.52359ZM16.0944 7.18267C16.0821 7.14383 16.078 7.10398 16.0811 7.06616C16.0893 6.93331 16.1792 6.81272 16.3141 6.77185C16.4878 6.71871 16.6718 6.81783 16.7249 6.99156L16.7576
               7.09887L17.0295 7.99205C17.0826 8.16578 16.9835 8.34974 16.8098 8.40287C16.636 8.45601 16.4521 8.35688 16.3989 8.18315L16.0944 7.18267ZM22.8483 8.29148C22.3424 8.26184 21.8591 8.08811 21.4544 7.79992C21.2571 7.65992 21.0783 7.49129 20.924 7.30018C20.7166 7.04163
               20.553 6.74017 20.4508 6.40292C20.272 5.81632 20.3057 5.21643 20.506 4.68503C20.6818 4.21904 20.9863 3.80514 21.39 3.49959L20.4447 0.391846L15.2032 1.98711L15.4117 2.67283C15.4648 2.84656 15.3657 3.03051 15.192 3.08365C15.0182 3.13679 14.8343 3.03766 14.7812
               2.86393L14.5727 2.17923L0.929874 6.33135L0.606934 6.42946L1.45821 9.22562H21.3963C21.5792 9.22562 21.7274 9.3738 21.7274 9.55672V12.0308L23.7958 11.4013L22.8495 8.29254L22.8483 8.29148Z"
                                  fill="black"
                                />

                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M14.718 12.5527C14.718 12.3697 14.8662 12.2216 15.0491 12.2216C15.232 12.2216 15.3802 12.3697 15.3802 12.5527V13.5981C15.3802 13.781
               15.232 13.9292 15.0491 13.9292C14.8662 13.9292 14.718 13.781 14.718 13.5981V12.5527ZM14.718 15.3323C14.718 15.1494 14.8662 15.0012 15.0491 15.0012C15.232 15.0012 15.3802 15.1494 15.3802 15.3323V16.3778C15.3802 16.5607 15.232 16.7089 15.0491 16.7089C14.8662
               16.7089 14.718 16.5607 14.718 16.3778V15.3323ZM14.718 18.112C14.718 17.9291 14.8662 17.7809 15.0491 17.7809C15.232 17.7809 15.3802 17.9291 15.3802 18.112V19.1575C15.3802 19.3404 15.232 19.4886 15.0491 19.4886C14.8662 19.4886 14.718 19.3404 14.718 19.1575V18.112ZM20.8561
               18.3597C20.8559 18.3595 20.8556 18.3593 20.8553 18.3592C20.3803 18.1834 19.9696 17.8769 19.6662 17.4835C19.3177 17.0318 19.1113 16.4667 19.1113 15.8546C19.1113 15.2424 19.3188 14.6773 19.6662 14.2256C19.8575 13.9776 20.0915 13.7641 20.3573 13.5961C20.6403
               13.4173 20.8558 13.1275 20.8558 12.7927V10.9021C20.8558 10.4602 20.4976 10.1021 20.0558 10.1021H16.0934C15.6989 10.1021 15.3791 10.4219 15.3791 10.8164C15.3791 10.9993 15.2309 11.1475 15.048 11.1475C14.865 11.1475 14.7169 10.9993 14.7169 10.8164C14.7169 10.4219
               14.397 10.1021 14.0025 10.1021L0.922503 10.103C0.480697 10.103 0.122559 10.4612 0.122559 10.903V12.7937C0.122559 13.1285 0.338031 13.4183 0.621048 13.5972C0.886861 13.7651 1.12079 13.9786 1.3121 14.2266C1.66058 14.6783 1.86702 15.2434 1.86702 15.8556C1.86702
               16.4677 1.65957 17.0329 1.3121 17.4846C1.12079 17.7326 0.886857 17.946 0.621042 18.114C0.338027 18.2928 0.122559 18.5827 0.122559 18.9174V20.8081C0.122559 21.2499 0.480731 21.6081 0.922559 21.6081H14.0036C14.3981 21.6081 14.7179 21.2883 14.7179 20.8938C14.7179
               20.7108 14.8661 20.5627 15.049 20.5627C15.2319 20.5627 15.3801 20.7108 15.3801 20.8938C15.3801 21.2883 15.6999 21.6081 16.0945 21.6081H20.0568C20.4986 21.6081 20.8568 21.2499 20.8568 20.8081V18.3614C20.8568 18.3607 20.8566 18.3601 20.8561 18.3597Z"
                                  fill="#000"
                                />

                              </svg>Ticketing 

                            </li> : ""
                          } */}
                          {/* <li className="worktualprolast" onClick={() => {
                            if (process.env.REACT_APP_ENV === 'production') {
                              switch (countryCode) {
                                case 'uk': {
                                  window.location.href = "https://myaccount.worktual.co.uk/";
                                  break;
                                }
                                case 'in': {
                                  window.location.href = "https://myaccount.worktual.in/";
                                  break;
                                }
                                case 'com': {
                                  window.location.href = "https://myaccount.worktual.com/";
                                  break;
                                }
                              }

                            } else if (process.env.REACT_APP_ENV === 'qa') {
                              switch (countryCode) {
                                case 'uk': {
                                  window.location.href = "https://qa-myaccount.worktual.co.uk/";
                                  break;
                                }
                                case 'in': {
                                  window.location.href = "https://qa-myaccount.worktual.in/";
                                  break;
                                }
                                case 'com': {
                                  window.location.href = "https://qa-myaccount.worktual.com/";
                                  break;
                                }
                              }
                            } else {
                              switch (countryCode) {
                                case 'uk': {
                                  window.location.href = "https://qamyaccount.worktual.co.uk/";
                                  break;
                                }
                                case 'in': {
                                  window.location.href = "https://qamyaccount.worktual.in";
                                  break;
                                }
                                case 'com': {
                                  window.location.href = "https://qamyaccount.worktual.com";
                                  break;
                                }
                              }
                            }
                          }}>My Account
                          </li> */}
                        </ul>
                      </div>
                    }
                  </div>

                </Tooltip>
                <div className={`${styles.profileAreadrop} ${styles.profdrophid}`}>
                  <div className={styles.profileArea}>
                    <div className={styles.profileAreastorage}>
                      <Popover placement="bottomRight" open={openProfile} content={content} trigger="click" overlayClassName="logoutMenu">
                        {/* <div className={`${GetItemFromStorage("getRandomColor3")}`} ref={profile}>

                          <Avatar
                            className="topheaderavatar eleventh-step eigth-step3 tenth-step"
                            size={28}
                          >
                            {LoginCcaasUserDetails?.UserName?.charAt(0)?.toUpperCase()}
                          </Avatar>


                        </div> */} 
                        {/* colortransperent */}
                        <div style={{display: 'flex', alignItems: 'center', gap: 6}} ref={arrowRef}> 
                          {!profileImage
                          ?
                         <div className={`${GetItemFromStorage("getRandomColor3")} eleventh-step eigth-step3 tenth-step`} >
                            {LoginCcaasUserDetails?.UserName?.charAt(0)?.toUpperCase()}
                         </div> :
                        <div >
                          <Avatar
                            className="topheaderavatar eleventh-step eigth-step3 tenth-step"
                            size={28}
                            src={profileImage}
                          >
                          </Avatar>
                        </div>}
                        <svg  className={styles.downarrow} xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                          <path d="M6.25643 5.90234C5.65393 5.90234 5.08843 5.66794 4.66313 5.24124L0.809634 1.37694C0.517134 1.08394 0.518134 0.609337 0.811134 0.316437C1.10503 0.0244375 1.58013 0.0244373 1.87213 0.318437L5.72513 4.18274C6.00883 4.46594 6.50443 4.46594 6.78713 4.18274L10.6406 0.318437C10.9326 0.0245373 11.4077 0.0245375 11.7016 0.316437C11.9946 0.609437 11.9955 1.08404 11.7031 1.37694L7.84963 5.24124C7.42433 5.66804 6.85853 5.90234 6.25643 5.90234Z" fill="#828385" />  </svg>

                        </div>
                      </Popover>
                    </div>
                  </div>
                  <div >
                    {/* <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
              <path d="M5.9996 5.90231C5.3971 5.90231 4.8316 5.66791 4.4063 5.24121L0.552798 1.37691C0.260298 1.08391 0.261298 0.609307 0.554298 0.316407C0.848198 0.024407 1.3233 0.0244068 1.6153 0.318407L5.4683 4.18271C5.752 4.46591 6.2476 4.46591 6.5303 4.18271L10.3838 0.318407C10.6758 0.0245068 11.1509 0.024507 11.4448 0.316407C11.7378 0.609407 11.7387 1.08401 11.4463 1.37691L7.5928 5.24121C7.1675 5.66801 6.6017 5.90231 5.9996 5.90231Z" fill="#757676"/>
              </svg> */}
                  </div>
                </div>
              </div>
            </div>
          </div> : <AgentFullScreen />}
          <Content className="siteMainInner">
            <Outlet />
          </Content>
        </Layout>
      </Layout>
      {userRoleId != ROLES.AGENT_ROLE_ID && (
        <Drawer title="Drawer with extra actions" placement={placement} width={672} open={open} className="customDrawer foragenttrackers topheadercustomdrawer antwrapts">
          <Tabs
            defaultActiveKey="1"
            className="queueTab"
            items={[
              {
                label: `Agent Status`,
                key: "1",
                children: <AgentStatusTracker DrawerControlfun={DrawerControl} />,
              },
              {
                label: (
                  <span className="withIcon">
                    Queue{" "}<span className="tagCount">{queueCount}</span>
                  </span>
                ),
                key: "2",
                children: <AgentQueueTracker />,
              },
            ]}
          />
          <span className={`${styles.drawerClose} ${styles.closebut}`}>
            <span className="icon__Close16" onClick={onClose} />
          </span>
        </Drawer>
      )}

      {userRoleId == ROLES.AGENT_ROLE_ID && (
        <Drawer title="Drawer with extra actions" placement={placement} width={500} open={open} className="customDrawer foragenttrackers">
          <Tabs
            defaultActiveKey="1"
            className="queueTab"
            items={[
              {
                label: (
                  <span className="withIcon">
                    Queue <span className="tagCount">{queueCount}</span>
                  </span>
                ),
                key: "2",
                children: <AgentQueueTracker />,
              },
            ]}
          />
          <span className={`${styles.drawerClose} ${styles.closebut}`}>
            <span className="icon__Close16" onClick={onClose} />
          </span>
        </Drawer>
      )}
      <Modal
        title={
          <p>
            <h5>Localisation</h5>
            <h6>Manage the language setting for interface </h6>
          </p>
        }
        open={createModal}
        onOk={() => handleCancel("create")}
        onCancel={() => handleCancel("create")}
        className="customModal localisationmodal sizeMD"
        centered
        maskClosable={false}
        destroyOnClose={true}
        closeIcon={<span className="icon__Close16"></span>}
        footer={[
          <Space>
            <WtButton name="Cancel" className="buttonCancel" onClick={() => handleCancel("create")} />
            <WtButton
              disabled={buttonSave === true}
              name={buttonSave === true ? <Lottie style={{ width: 50, margin: "0 auto" }} animationData="" /> : "Save"}
              className="buttonSave"
              htmlType="submit"
            />
          </Space>,
        ]}
      >
        <Form name="basic" preserve={false} labelCol={{ span: 8 }} wrapperCol={{ span: 24 }} initialValues={{ remember: true }} autoComplete="off" className="antForm">
          <Row align="top" className={`grdinputheight ${styles.grd}`}>
            <Col sm={8}>
              <span className="lblName">Languages </span>
            </Col>
            <Col sm={16}>
              <div>
                <Form.Item style={{ width: "100%" }} name="Languages">
                  <Select
                    className="antSelect"
                    defaultValue={language}
                    popupClassName="antSelectPopover"
                    suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                      <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676" />
                    </svg>}
                    placeholder="Select Language"
                    onChange={(e: any) => handleLanguage(e)}
                    value={languageChange}
                    options={[
                      {
                        value: "en",
                        label: "English",
                      },
                      {
                        value: "nl",
                        label: "Dutch",
                      },
                      {
                        value: "de",
                        label: "German",
                      },
                      {
                        value: "fr",
                        label: "French",
                      },
                      {
                        value: "gr",
                        label: "Greek",
                      },
                    ]}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal
        title={
          <p>
            <h5>ENTER URL</h5>
          </p>
        }
        open={domainUrl}
        onOk={() => setUrl()}
        onCancel={() => serDomainUrl(false)}
        className="customModal localisationmodal sizeMD"
        centered
        maskClosable={false}
        destroyOnClose={true}
        closeIcon={<span className="icon__Close16" onClick={() => serDomainUrl(false)}></span>}
        footer={[
          <Space>
            <WtButton name="Cancel" className="buttonCancel" onClick={() => serDomainUrl(false)} />
            <WtButton
              disabled={buttonSave === true}
              name={buttonSave === true ? <Lottie style={{ width: 50, margin: "0 auto" }} animationData="" /> : "Save"}
              className="buttonSave"
              onClick={() => setUrl()}
              htmlType="submit"
            />
          </Space>,
        ]}
      >
        <Form name="basic" preserve={false} labelCol={{ span: 8 }} wrapperCol={{ span: 24 }} initialValues={{ remember: true }} autoComplete="off" className="antForm">
          <Row align="top" className={`grdinputheight ${styles.grd}`}>
            <Col sm={16}>
              <div>
                <Form.Item style={{ width: "100%" }} name="Languages">
                  <AntInput
                    onKeyDown={(e: any) => {
                      if (e.which == "13") {
                        e.preventDefault();
                      } else if (e.target.value.length < 1 && e.which == "32") {
                        e.preventDefault();
                      }
                    }}
                    value={WSSURL}
                    onChange={(e: any) => setWSSURL(e.target.value)}
                    className="textBox"
                    placeHolder="Name of the Business Hours"
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>

      {notificationRefreshData?.isPlanUpgrade && <Upgdradeplan />}

    </>
  );
}

export { MainLayout };

